{
  "heroic_approval": {
    "karma": "Karma",
    "setting_hint": "Zeigt die gutgeschriebenen XP und Karma, wenn eine gute Tat bestätigt wurde."
  },
  "category_milestones": {
    "description": "Sammle Kategorie-XP, schalte Titel und Abzeichen frei und wähle einen Titel für dein Profil."
  },
  "level_up": {
    "setting": "Popups bei Charakter-Levelaufstiegen anzeigen"
  },
  "profile_identity": {
    "subtitle": "Dein Abenteurerprofil"
  },
  "adventureFlow": {
    "intro": "Dein Einsatz zählt. Aus echten guten Taten wird ein Abenteuer, das dich und deine Umgebung weiterbringt."
  },
  "flyers": {
    "adventurer": {
      "title": "Dein Abenteuer auf einen Blick",
      "body": "Gute Taten, Erfahrung, Gilden und echte Vorteile: Der Abenteurer-Flyer zeigt dir, wie Goodvale funktioniert. Zum Herunterladen und Teilen.",
      "alt": "Vorschau des Goodvale-Abenteurer-Flyers"
    }
  },
  "partnersPage": {
    "intro": "Goodvale macht gute Taten zum Abenteuer: Menschen engagieren sich, sammeln Erfahrung und steigen im Rang auf. Dein Betrieb belohnt dieses Engagement mit passenden Angeboten und gibt neuen Kunden einen Grund, dich zu entdecken.",
    "example": "Beispiel: Dein Café bietet 10 % Rabatt ab Rang E, einmal pro Person und Woche.",
    "steps": [
      {
        "title": "Engagieren & entdecken",
        "body": "Lea tut Gutes, erreicht Rang E und entdeckt dein Café und den passenden Vorteil in Goodvale."
      },
      {
        "title": "QR-Pass oder digital",
        "body": "Lea zeigt ihren QR-Pass zum Scannen. Bei einem digitalen Angebot löst sie es in der App ein und nutzt den bereitgestellten Code. Goodvale prüft Voraussetzungen und Limits."
      },
      {
        "title": "Vorteil erhalten",
        "body": "Dein Team bestätigt vor Ort die Einlösung und gewährt den Rabatt an der Kasse: Aus 10 € werden 9 €. Die Einlösung wird gespeichert."
      }
    ]
  },
  "class_change": {
    "current": "Deine aktuelle Klasse",
    "preview": "Deine neue Klasse",
    "preview_hint": "Wähle ein Klassen-Icon, um Fähigkeiten und Boni zu entdecken.",
    "xp_safe": "Deine bisherigen XP bleiben erhalten",
    "title": "Klasse ändern",
    "explanation": "Du kannst deine Klasse innerhalb von sieben Tagen nach der Registrierung einmalig ändern. Deine bisherigen XP und Level bleiben unverändert. Laufende Heldentaten behalten ihre gespeicherten Boni.",
    "choose": "Neue Klasse auswählen",
    "confirm": "Möchtest du diese Klasse endgültig wählen? Du kannst deine Klasse danach nicht erneut ändern. Deine bisherigen XP bleiben unverändert.",
    "save": "Klasse einmalig wechseln",
    "success": "Deine Klasse wurde geändert. Deine bisherigen XP bleiben erhalten.",
    "error": "Die Klasse konnte nicht geändert werden.",
    "load_error": "Die Klassen konnten nicht geladen werden.",
    "used": "Du hast deinen einmaligen Klassenwechsel bereits genutzt.",
    "unavailable": "Der Klassenwechsel ist nicht verfügbar. Er ist nur während der ersten sieben Tage möglich."
  },
  "ui_text": {
    "admin_dashboard": {
      "intro": "Aggregierte Echtzeit-Informationen zu Moderation, Partneranträgen, Gilden, Benutzern und Audit-Logs.",
      "guilds_stat": "Gilden",
      "active_guilds": "Aktive Gilden im Spiel",
      "no_pending_deeds": "Keine offenen guten Taten zur Prüfung im Tribunal vorhanden.",
      "recent_users_intro": "Kürzlich registrierte Abenteurer & Profile",
      "guilds_and_foundings": "Gilden & Gründungen",
      "guilds_intro": "Gildenübersicht und Gildex-Punkte",
      "all_guilds": "Alle Gilden",
      "no_guilds": "Bisher sind keine Gilden gegründet worden."
    },
    "admin_class_category": {
      "title": "Klassen & Kategorien Konfigurator",
      "intro": "Konfiguriere Heldenklassen, Perks sowie Gute-Taten- und Partnerkategorien inkl. Soft-Delete.",
      "loading_classes": "Lade Klassen & Perks...",
      "no_classes": "Keine Klassen vorhanden.",
      "general_xp_bonus": "Allgemeiner Gute-Taten-XP-Bonus",
      "cooldown_reduction": "Gute-Taten-Cooldown-Reduzierung"
    },
    "partner_offer_editor": {
      "good_deed_requirement": "Bestätigte gute Tat / Quest (optional)",
      "map_intro": "Klicke direkt auf die Karte oder wähle eine Schnelloption, um den Standort für Abenteurer zu setzen.",
      "guild_category": "Gilden-Kategorie",
      "max_per_adventurer": "Max. Einlösungen pro Abenteurer (optional)"
    },
    "guild_members_admin": {
      "banned_adventurers": "Gesperrte Abenteurer",
      "loading_bans": "Lade gesperrte Abenteurer...",
      "no_bans": "Keine aktiven Gilden-Sperren",
      "ban_adventurer": "Abenteurer aus Gilde bannen",
      "ban_warning": "Abenteurer:in wird sofort aus der Gilde entfernt und zukünftige Beitrittsanfragen werden dauerhaft blockiert.",
      "ban_reason": "Begründung für die Gilde (Optional):"
    },
    "guild_branding": {
      "loading": "Lade Gilden-Branding...",
      "emblem_intro": "Gestalte das modulare Wappen deiner Gilde aus Symbol, Rahmen, Flügeln, Helmzier, Basis und Farbschema.",
      "unlock_forge": "Wappenschmiede im Shop freischalten",
      "details_title": "Gilden-Stammdaten & Aushängeschild",
      "details_intro": "Diese Informationen sind für alle Abenteurer auf der Gildenhaus-Startseite und in der Übersicht sichtbar.",
      "motto": "Gilden-Motto & Philosophie / Beschreibung:",
      "location": "Gilden-Standort (Koordinaten): *"
    },
    "guild_detail_misc": {
      "back_to_guilds": "Zurück zur Gildenübersicht",
      "ban_confirm": "Möchtest du dieses Mitglied wirklich dauerhaft aus der Gilde verbannen?",
      "sole_leader_warning": "Du bist der einzige Gildenleiter. Bitte ernenne eines der verbleibenden Mitglieder zum Gilden-Admin, um die Gilde verlassen zu können."
    },
    "admin_tribunal_moderators": {
      "applications_intro": "Neue Bewerbungen von Abenteurern ab Rang C erscheinen hier zur Genehmigung oder Ablehnung."
    },
    "heroic_actions_misc": {
      "rules_slots_timing": "Bei Einzelaktionen beginnt die Wartezeit mit der XP-Gutschrift. Bei Gruppenaktionen zählt sie ab der Anmeldung und startet bei der Gutschrift nicht erneut. Unter „Meine Slots“ siehst du deine aktuelle Belegung und verbleibende Wartezeiten."
    },
    "admin_heroic_actions": {
      "rank_f": "Rang F (Novize)",
      "rank_e": "Rang E (Entdecker)",
      "rank_d": "Rang D (Pionier)",
      "rank_c": "Rang C (Hüter)",
      "rank_b": "Rang B (Meister)",
      "rank_a": "Rang A (Elite)",
      "rank_s": "Rang S (Legende)"
    },
    "game_mechanics_misc": {
      "view_classes_ranks": "Klassen ansehen"
    },
    "guilds_misc": {
      "no_guild_intro": "Du bist aktuell in keiner Gilde. Gründe deine eigene Gilde oder schließe dich einer Gemeinschaft an!"
    }
  },
  "guild_rooms": {
    "hall": "Gildenhalle",
    "navigation": "Navigation im Gildenhaus",
    "treasury": "Schatzkammer",
    "shop": "Gilden-Shop",
    "trophies": "Trophäenraum",
    "forge": "Wappenschmiede",
    "stats": "Ruhm & Statistik"
  },
  "hero_card": {
    "title": "Heldenvisitenkarte",
    "karma": "Karma",
    "guild": "Gilde",
    "qr": "Aktueller Heldenpass"
  },
  "dialogs": {
    "moderator_title": "Werde Teil des Tribunals"
  },
  "app": {
    "adventurer": "Abenteurer:in {{name}}",
    "rank_class": "Rang {{rank}} • {{class}}"
  },
  "world": {
    "nav": {
      "guild": "Gilde"
    }
  },
  "common": {
    "adventurer": "Abenteurer:in",
    "rank": "Rang {{rank}}"
  },
  "nav": {
    "dashboard": "Abenteurer-Ausweis",
    "talents": "Talente",
    "tavern": "Taverne",
    "guilds": "Gilden",
    "classes_ranks": "Klassen & Ränge",
    "classes": "Klassen",
    "ranks": "Ränge",
    "world_guild_mgmt": "Gilden-Management",
    "good_deeds": "Gute Taten & XP"
  },
  "karma": {
    "title": "Karma · Vertrauen",
    "subtitle": "Dein Verhaltenskodex und deine Reputation in der Gilde.",
    "points": "{{score}} Karma-Punkte",
    "open_barometer": "Karma-Balken im Profil öffnen",
    "markers_title": "Karma-Schwellen und Voraussetzungen",
    "marker_guild": "Gildengründung",
    "marker_guild_detail": "Mindest-Karma; Rang und gute Taten sind zusätzlich nötig.",
    "marker_tribunal": "Tribunalbewerbung",
    "marker_tribunal_detail": "Mindest-Karma; zusätzlich ist Rang {{rank}} nötig.",
    "marker_neutral_detail": "Keine Karma-Sanktion.",
    "marker_partner_detail": "Gilt von {{partner}} bis {{minimum}} Karma.",
    "marker_xp": "Täglicher XP-Abzug",
    "marker_xp_detail": "Gilt von {{xp}} bis {{xpEnd}}; täglich {{percent}} % der Gesamt-XP.",
    "marker_tribunal_loss": "Tribunalrecht entfällt",
    "marker_tribunal_loss_detail": "Ab {{tribunalLoss}} wird eine bestehende Tribunalrolle entzogen.",
    "tier_trusty_desc": "Positives Karma durch regelmäßige, verifizierte gute Taten.",
    "tier_neutral_desc": "Ausgeglichenes Karma. Reiche gute Taten ein oder unterstütze deine Gilde.",
    "tier_warned_desc": "Ab {{partner}} Karma sind Partnervorteile gesperrt. Bestätigte gute Taten bauen Vertrauen wieder auf.",
    "tier_outlaw": "Täglicher XP-Abzug",
    "tier_outlaw_desc": "Von {{xp}} bis {{xpEnd}} Karma werden täglich {{percent}} % deiner aktuellen Gesamt-XP abgezogen.",
    "tier_banned_desc": "Dein Konto wurde separat gesperrt. Die Kontosperre ist unabhängig vom Karma-Wert.",
    "rules": "Karma reicht von {{minimum}} bis {{maximum}}. Ab {{partner}} sind Partnervorteile gesperrt, ab {{xp}} gehen täglich {{percent}} % Gesamt-XP verloren und ab {{suspension}} wird das Konto {{months}} Kalendermonat(e) gesperrt.",
    "tier_restricted_desc": "Von {{suspension}} bis {{minimum}} Karma wird dein Konto für {{months}} Kalendermonat(e) gesperrt. Eine separate Admin-Sperre bleibt davon unberührt.",
    "tier_released_desc": "Die temporäre Kontosperre ist abgelaufen. Bei diesem Karma-Wert bleiben Partnervorteile gesperrt.",
    "moderate": "Karma verwalten",
    "moderation_hint": "Abzüge durch Gilden-Admins benötigen die Bestätigung eines System-Admins. Nach Bestätigung sieht die betroffene Person deine Begründung und deinen Namen.",
    "deduction": "Karma-Abzug (1–100 Punkte)",
    "submit": "Karma abziehen & benachrichtigen",
    "saved": "Karma-Abzug gespeichert und Benachrichtigung erstellt.",
    "pending_saved": "Karma-Abzug zur Bestätigung an den System-Admin gesendet.",
    "pending_title": "Ausstehende Karma-Abzüge",
    "pending_notification": "{{actor}} beantragt −{{points}} Karma für {{target}}.",
    "history": "Karma · Begründete Abzüge",
    "no_penalties": "Keine Karma-Abzüge vorhanden.",
    "scope": "Gildenadmins können Mitglieder ihrer eigenen Gilde verwalten. Superadmins können gildenübergreifend handeln.",
    "penalty_notification_title": "Dein Karma wurde angepasst",
    "penalty_notification": "{{actor}} hat dein Karma um {{delta}} Punkte angepasst. Neuer Wert: {{score}}. Begründung: {{reason}}"
  },
  "tavern": {
    "detail": {
      "back": "Zurück zur Taverne"
    },
    "feed": {
      "adventurer": "Abenteurer:in {{name}}",
      "guild": "Gilde: {{name}}",
      "xpEarned": "+{{xp}} XP erhalten",
      "partnerJoined": "Partner {{name}} ist nun Teil von Goodvale"
    },
    "title": "Taverne",
    "empty": "Es ist ruhig in der Taverne heute.",
    "rank": "Rang {{rank}}"
  },
  "guilds": {
    "decorations": {
      "stages": {
        "4": "Legendär"
      },
      "title": "Freigeschaltete Gildendekorationen",
      "renown": "Ruhmstufe",
      "forest": "Waldhalle",
      "bronzeFrame": "Bronzener Wappenrahmen",
      "celestial": "Sternenhalle"
    },
    "memberBanner": {
      "title": "Du bist Mitglied der Gilde „{{name}}“",
      "memberSubtitle": "Ehre und Ruhm deinem Banner! Besuche dein Gildenhaus oder erkunde andere Bündnisse der Welt.",
      "guildhouseBtn": "Mein Gildenhaus betreten"
    },
    "createModal": {
      "title": "Neue Gilde gründen",
      "namePlaceholder": "Gildenname (max. 60 Zeichen)",
      "descPlaceholder": "Gildenphilosophie / Beschreibung (optional, max. 300 Zeichen)",
      "submit": "Gilde gründen",
      "nameRequired": "Ein Gildenname ist erforderlich.",
      "nameTooLong": "Gildenname darf max. 60 Zeichen haben.",
      "locationTitle": "Gilden-Standort",
      "emblemTitle": "Heraldisches Wappen wählen",
      "creating": "Gilde wird gegründet…"
    },
    "createPage": {
      "subtitle": "Erschaffe ein neues Bündnis in der Gildenwelt",
      "description": "Lege den Namen, die Philosophie, das heraldische Wappen und den Standort deines neuen Gildenhauses auf der Weltkarte fest.",
      "basicInfoTitle": "1. Gildeninformationen",
      "requirements": "Mindestens Rang {{rank}}, {{actions}} bestätigte gute Taten und {{karma}} Karma. Du darfst keiner Gilde angehören. Nach Auflösung oder Übergabe deiner eigenen Gilde gelten {{days}} Tage Wartezeit.",
      "requirementsIntro": "Für die Gildengründung brauchst du:",
      "rankProgress": "Rang {{required}} (aktuell: {{current}})",
      "karmaProgress": "{{required}} Karma (aktuell: {{current}})",
      "cooldownUntil": "Wartezeit nach Gildenleitung bis {{date}}",
      "cooldownReady": "{{days}} Tage Wartezeit nach Auflösung oder Übergabe einer eigenen Gilde",
      "noGuildRequirement": "Du darfst keiner anderen Gilde angehören.",
      "forgeHint": "Weitere Wappendesigns und Farben kannst du nach der Gründung in der Wappenschmiede im Gilden-Shop mit Gildex freischalten."
    },
    "title": "Gilden-Zentrum",
    "subtitle": "Finde eine Gilde oder gründe deine eigene.",
    "description": "Finde eine Gemeinschaft, die zu dir passt. Entdecke Gilden und gestaltet eure Welt durch gemeinsame gute Taten.",
    "renownPts": "Ruhmpunkte",
    "directory_title": "Gilden-Verzeichnis",
    "directory_intro": "Entdecke andere Gilden und schließe dich einer Gemeinschaft an.",
    "founding_title": "Eigene Gilde gründen",
    "clear_search": "Gildensuche leeren",
    "pagination_label": "Seiten des Gilden-Verzeichnisses",
    "empty": "Noch keine Gilden vorhanden.",
    "loadError": "Gilden konnten nicht geladen werden.",
    "create": "Gilde gründen",
    "yourGuild": "Deine Gilde",
    "yourGuildAdmin": "Deine Gilde (Admin)",
    "inOtherGuild": "In anderer Gilde",
    "enterGuildhouse": "Gildenhaus betreten",
    "back_to_guilds": "Alle Gilden",
    "backToGuilds": "Zurück zur Gildenübersicht",
    "card_description": "Ehrenhafte Gemeinschaft in der Gildenwelt.",
    "house_status": "Gildenhaus-Status",
    "ausgew_hltes_gildenw": "Ausgewähltes Gildenwappen",
    "gildenhaus": "Gildenhaus",
    "entdecke_andere_gild": "Entdecke andere Gilden und schließe dich einer Gemeinschaft an.",
    "du_bist_aktuell_in_k": "Du bist aktuell in keiner Gilde. Gründe deine eigene Gilde oder schließe dich einer Gemeinschaft an!",
    "gilde_suchen_placeholder": "Gilde suchen..."
  },
  "share": {
    "subtitle": "Lade andere Abenteurer ein, sich der Gilde anzuschließen und die Welt zu erkunden!"
  },
  "pos": {
    "title": "Gildenhaus POS & QR-Verifikation",
    "subtitle": "Scanne Abenteurer-Pässe, verifiziere Signaturen und werte Vor-Ort-Rabatte in Echtzeit aus.",
    "standby_desc": "Halte den QR-Ausweis einer Abenteurer:in vor die Kamera."
  },
  "qr_pass": {
    "modal_badge": "Offizieller Gilden-Ausweis"
  },
  "profile_v2": {
    "progress_line": "Rang {{rank}} · Level {{level}} · {{xp}} XP",
    "preferences": "Darstellung",
    "moderator_title": "Tribunal-Moderator werden",
    "moderator_help": "Ab Rang {{rank}} und {{karma}} Karma kannst du dich bewerben. Erst nach Admin-Freigabe werden dir unabhängige Prüfungen zugewiesen.",
    "delete_confirm": "Möchtest du dein Konto wirklich dauerhaft anonymisieren? Beweisdateien und Kontaktdaten werden gelöscht. Falls du das letzte Mitglied deiner Gilde bist, wird auch die Gilde endgültig gelöscht."
  },
  "map_v2": {
    "guilds": "Gilden"
  },
  "chats_v2": {
    "permission_guild": "Personen in derselben Gilde wie ich",
    "subtitle": "Private Gespräche zwischen Abenteurern. Die Gildenorganisation findet im Gildenchat statt.",
    "search": "Abenteurer suchen …",
    "rank": "Rang {{rank}}",
    "rank_class": "Rang {{rank}} · {{heroClass}}"
  },
  "game_mechanics": {
    "groups": {
      "text": "Gildenadmins dürfen freiwillige, nicht kommerzielle Gruppenaktionen ausrufen. Mitglieder melden sich an und bestätigen ihre Teilnahme nach Beginn. Der Organisator verteilt die Gesamt-XP auf bestätigte Teilnehmende; niemand darf mehr als 50 % erhalten. Das Tribunal prüft die Verteilung. Partner dürfen daraus keine verdeckten Arbeitsaufträge machen."
    },
    "removed": {
      "text": "Es gibt keine käufliche oder übertragbare Spielwährung. Fortschritt entsteht ausschließlich durch bestätigte gute Taten und kann weder gekauft noch zwischen Personen übertragen werden. Gilden und Partner vergeben keine bezahlten Aufträge und erhalten keinen Anteil an deiner Erfahrung. Auch Abkürzungen beim Rangaufstieg oder steuerähnliche Spielmechaniken gibt es nicht."
    },
    "ai_abuse": {
      "text": "Goodvale basiert auf real erbrachten Taten und gegenseitigem Vertrauen. Die missbräuchliche Nutzung von KI zur Erstellung, Fälschung oder Manipulation von guten Taten und Nachweisen ist strengstens untersagt. Jeder festgestellte KI-Missbrauch wird mit negativem Karma und gegebenenfalls mit dem Bannen des Kontos bestraft."
    },
    "karma": {
      "neutral": {
        "title": "Keine Karma-Sanktion"
      },
      "xp": {
        "title": "Zusätzlich täglicher XP-Abzug",
        "text": "Einmal pro UTC-Tag werden {{percent}} % der aktuellen Gesamt-XP abgezogen. Der Prozentsatz ist in den Systemeinstellungen änderbar. Kategorie-XP bleiben erhalten; Level und Rang werden neu berechnet."
      },
      "tribunal": {
        "title": "Tribunalrecht entfällt",
        "text": "Ab {{tribunalLoss}} Karma wird eine bestehende Tribunalrolle entzogen; eine offene Bewerbung wird zurückgesetzt. Nach Erholung ist eine neue Bewerbung nötig. Dafür gelten Rang {{tribunalRank}} und mindestens {{tribunalMinimum}} Karma; die Werte sind einstellbar."
      },
      "suspension": {
        "text": "Das Konto wird für {{months}} Kalendermonat(e) gesperrt. Währenddessen gibt es keinen täglichen XP-Abzug. Danach endet diese Karma-Sperre automatisch."
      },
      "title": "Karma im Detail",
      "intro": "Karma beginnt bei 0 und reicht von {{minimum}} bis {{maximum}}. Bestätigte gute Taten erhöhen es; abgelehnte oder zurückgezogene Taten verursachen allein keinen Abzug. Bei begründetem Fehlverhalten können Admins Karma abziehen.",
      "note": "Der tägliche Abzug wird auf ganze XP aufgerundet, endet bei 0 XP und erscheint im XP-Ledger. Nach Ablauf der Sperre bleiben Partnervorteile bei gesperrtem Karma gesperrt. Eine separate Admin-Sperre endet nur durch manuelle Freigabe. Bestätigte gute Taten können Karma wieder aufbauen."
    },
    "subtitle": "Gute Taten einreichen, unabhängig prüfen lassen, XP sammeln und passende Partnerangebote freischalten.",
    "flow": [
      {
        "title": "1. Gute Tat",
        "description": "Du beschreibst eine bereits erbrachte, freiwillige gute Tat und reichst den nötigen datensparsamen Nachweis ein."
      },
      {
        "title": "2. Tribunal",
        "description": "Die erste Prüfung ordnet Zeit und Einsatz, Planung und Abstimmung sowie XP ein. Die XP-Höhe bestimmt, ob insgesamt eine, zwei oder drei unabhängige Prüfungen und zusätzlich ein Admin nötig sind."
      },
      {
        "title": "3. Fortschritt",
        "description": "Erst die endgültige Zustimmung schreibt globale und Kategorie-XP ins unveränderliche XP-Ledger. Level, Rang und Kategorie-Level werden daraus berechnet."
      },
      {
        "title": "4. Partner",
        "description": "Angebote können Rang, Level, globale XP, Kategorie-XP oder eine bestätigte Systemaktion voraussetzen. Eingelöst wird mit einem kurzlebigen, signierten Einmal-QR-Pass."
      }
    ],
    "gildex": {
      "title": "Gildex und Schatzkammer",
      "text": "Bei einer bestätigten guten Tat erhält die bei Einreichung festgehaltene Gilde zusätzlich einen administrierbaren Anteil der Basis-XP als Gildex. Spieler-XP werden nicht gekürzt. Gildex haben keinen Geldwert, sind nicht kaufbar, auszahlbar oder übertragbar und gelten nicht bei Partnern. Gildenadmins können damit ausschließlich interne Dekorationen und Komfortfunktionen freischalten."
    },
    "perks": {
      "title": "Klassen und Talente",
      "items": [
        {
          "title": "Mehr Erfahrung",
          "description": "Einige Klassen und Talente geben dir nach der Bestätigung zusätzliche XP für deine gute Tat."
        },
        {
          "title": "Mehr gleichzeitig tun",
          "description": "Zusätzliche Plätze erlauben dir, mehrere gute Taten oder Gruppenaktionen parallel laufen zu lassen."
        },
        {
          "title": "Kürzere Wartezeit",
          "description": "Bestimmte Fähigkeiten verkürzen die Zeit bis zu deiner nächsten Einreichung."
        },
        {
          "title": "Gemeinsam mehr erreichen",
          "description": "Der Barde erhöht die XP einer bestätigten Gruppenaktion um 10 %. Der Bonus zählt auch mit mehreren Barden nur einmal."
        },
        {
          "title": "Fortschritt in einer Kategorie",
          "description": "Kategorie-XP stärken deinen Fortschritt im passenden Bereich. Deine Gesamt-XP bleiben davon getrennt."
        },
        {
          "title": "Karma verbessern",
          "description": "Einige Talente stärken dein Karma nach bestätigten guten Taten. Die Prüfung deiner Nachweise bleibt davon unabhängig."
        },
        {
          "title": "Erfahrungselixier",
          "description": "Als Alchemist kannst du einmal pro Kalenderwoche vor einer Einzelaktion ein kostenloses Elixier einsetzen. Bei Bestätigung erhältst du 25 % mehr Gesamt-XP und Kategorie-XP."
        }
      ]
    },
    "principles_title": "Grundsätze und Gildenmechanik",
    "classes_link": "Alle 10 Klassen ansehen",
    "start_description": "Wähle deine Heldenklasse, dokumentiere deinen ersten ehrenamtlichen Beitrag und sammle verifizierte Erfahrung."
  },
  "player_progress": {
    "xp_value": "{{xp}} XP",
    "next_level_xp": "Bis zum nächsten Level: {{xp}} XP",
    "next_level_xp_short": "Noch {{xp}} XP"
  },
  "level_statistics": {
    "subtitle": "Level {{level}} · {{xp}} XP insgesamt. Verfolge deinen Fortschritt und die bestätigten guten Taten, mit denen du Erfahrung gesammelt hast.",
    "xp_to_talent": "XP bis zum nächsten Talentpunkt",
    "talent_point_ready": "Talentpunkt verfügbar",
    "talent_points_max": "Alle Talentpunkte erreicht",
    "xp": "XP",
    "monthly_xp": "XP im Monat",
    "zero": "0 XP",
    "no_history": "In den letzten zwölf Monaten gab es noch keinen XP-Zuwachs.",
    "deeds_title": "Gute Taten & erhaltene XP",
    "no_deeds": "Es gibt noch keine bestätigten guten Taten mit XP."
  },
  "slotsPage": {
    "groupStillActive": "Abgelaufen · Quest noch aktiv",
    "skipSuccess": "Cooldown übersprungen. Der Slot ist jetzt frei.",
    "skipError": "Der Cooldown konnte nicht übersprungen werden."
  },
  "dashboard_v2": {
    "adventurer_kicker": "Goodvale · Abenteurer:in",
    "free_adventurer": "Freie Abenteurer:in",
    "hero_class": "Heldenklasse",
    "class": "Klasse",
    "class_category_bonus": "Klassenbonus +{{percent}} % XP",
    "other_category_bonus": "+{{percent}} % Kategorie-XP",
    "next_talent_point": "Nächster Talentpunkt: Lv. {{level}}",
    "no_talents": "Noch keine Talente freigeschaltet",
    "reset_banner": "Klassenmotiv wiederherstellen",
    "talents_panel_title": "Deine Talente",
    "available_talent_points": "Verfügbare Talentpunkte",
    "open_talent_tree": "Talentpfade öffnen",
    "class_panel_title": "Klasse & Spezialisierung",
    "open_class_progress": "Klassen- und Rangfortschritt öffnen",
    "eyebrow": "Abenteurer-Zentrale",
    "subtitle": "Reiche gute Taten ein, verfolge Tribunalentscheidungen und baue deinen Charakter- und Kategorie-Fortschritt aus.",
    "go_to_guild": "Zu meiner Gilde",
    "no_guild": "Noch keiner Gilde beigetreten",
    "browse_guilds": "Zu den Gilden",
    "open_tribunal": "Tribunal öffnen",
    "total_xp": "Gesamt-XP",
    "rank": "Rang",
    "class_and_rank": "{{heroClass}} · Rang {{rank}}",
    "xp_value": "{{xp}} XP",
    "karma": "Karma",
    "apply_moderator_help": "Ab Rang C kannst du dich für unabhängige Tribunalprüfungen bewerben.",
    "moderator_prompt": "Warum möchtest du Tribunal-Moderator werden?",
    "status_PendingReview": "Tribunalprüfung"
  },
  "partner_offers": {
    "form_level": "Charakter-Level",
    "redemption_channel_help": "Wähle, wo und wie dein Angebot von Abenteurern eingelöst werden kann.",
    "freq_once_ever": "Einmalig pro Abenteurer",
    "subtitle": "Lege fest, welcher bestätigte Fortschritt ein Angebot freischaltet. XP werden dabei nicht ausgegeben.",
    "empty_desc": "Erstelle dein erstes Partnerangebot mit Rang-, XP-, Kategorie- oder Gute-Tat-Voraussetzung.",
    "modal_subtitle": "Wird im POS beim Scannen von Abenteurern automatisch geprüft.",
    "req_karma": "Min. Karma: {{karma}}",
    "responsibility_confirmation": "Ich bestätige, dass ich für Inhalt, Verfügbarkeit und Erfüllung dieses Angebots verantwortlich bin. XP werden nicht verbraucht, sind nicht übertragbar und haben keinen Geldwert.",
    "form_rank": "Mindest-Rang",
    "form_global_xp": "Gesamt-XP",
    "form_category_xp": "Kategorie-XP",
    "form_honor": "Mindest-Karma",
    "req_rank": "ab Rang {{rank}}",
    "req_global_xp": "{{xp}} Gesamt-XP",
    "req_category_xp": "{{xp}} XP in {{category}}",
    "category_required": "Wähle eine Kategorie für die Kategorie-Level- oder XP-Bedingung."
  },
  "errors": {
    "medic_notice": " (inkl. Kleriker-Bonus +1 Rang)",
    "merchant_notice": " (inkl. Spezial- / Talent-Bonus)",
    "tank_notice": " inkl. Verteidiger-Bonus"
  },
  "error": {
    "desc": "Ein unerwarteter Fehler ist aufgetreten. Unser Tribunal wurde automatisch informiert."
  },
  "register": {
    "field_contact": "Kontakt für Abenteurer",
    "field_contact_hint": "So erreichen dich Abenteurer (z. B. Telefonnummer, E-Mail oder Website).",
    "field_contact_required": "Bitte gib einen Kontakt für Abenteurer an.",
    "role_adventurer": "Abenteurer:in",
    "role_partner": "Partner (Gildenhaus)",
    "class": "Heldenklasse",
    "class_required": "Bitte wähle eine Klasse.",
    "class_title": "Wähle deine Klasse",
    "classesSubtitle": "Zehn Klassen, ein gemeinsames Ziel: echte gute Taten sichtbar machen.",
    "class_hint": "Jede Klasse erhält +20 % Gesamt- und Kategorie-XP für bestätigte gute Taten ihrer Kategorie und eine besondere Klassenfähigkeit.",
    "class_hint_bold": "Du kannst deine Klasse im Profil innerhalb der ersten sieben Tage nach der Registrierung einmalig ändern. Danach ist deine Wahl endgültig. Bereits gutgeschriebene XP bleiben unverändert.",
    "field_category_note": "Wichtig für das Trigger-System der Abenteurer-Klassen.",
    "class_scout": "Späher",
    "class_medic": "Kleriker",
    "class_social": "Barde",
    "class_tank": "Verteidiger",
    "class_environment": "Druide",
    "class_tech": "Magier",
    "class_crafter": "Schmied",
    "class_nutrition": "Alchemist",
    "class_logistics": "Händler",
    "class_guardian": "Paladin",
    "classes_loading": "Klassenfähigkeiten werden geladen …",
    "classes_error": "Klassenfähigkeiten konnten nicht geladen werden. Bitte versuche es erneut."
  },
  "login": {
    "subtitle": "Anmeldung für Abenteurer und Partner"
  },
  "public_profile": {
    "bio_title": "Über diesen Abenteurer",
    "no_bio": "Für dieses Abenteurerprofil wurde noch keine Beschreibung hinterlegt.",
    "karma_score": "Karma-Score",
    "rank": "Rang {{rank}}",
    "visitor_title": "Abenteurerprofil"
  },
  "location_picker": {
    "hint": "Klicke auf den Standort deines Betriebs oder deiner Gilde. Dieser Ort wird auf der Weltkarte öffentlich angezeigt."
  },
  "admin_nav": {
    "tribunal_moderators": "Tribunal-Moderatoren",
    "karma": "Karma-Verwaltung",
    "class_categories": "Klassen, Perks & Kategorien",
    "heroic_actions": "Tribunal",
    "xp_audits": "XP-Prüfung",
    "guild_hall": "Gildenhallen-Editor"
  },
  "xp_audit": {
    "title": "XP-Auffälligkeiten",
    "intro": "Prüfe schnell vergebene XP. Zurückgehaltene Belohnungen wirken sich bis zur Entscheidung nicht auf Rang und Fortschritt aus.",
    "recent_awards": "Letzte XP-Buchungen",
    "player_pending": "XP bis zur Admin-Prüfung zurückgehalten",
    "approve": "XP freigeben",
    "reject": "XP ablehnen",
    "load_error": "Die XP-Prüffälle konnten nicht geladen werden."
  },
  "admin_tribunal_moderators": {
    "title": "Tribunal-Moderatoren & Bewerbungen",
    "subtitle": "Prüfe offene Bewerbungen von Abenteurern ab Rang C und verwalte bestehende Moderatorenrechte des Tribunals.",
    "no_moderators": "Derzeit sind keine Tribunal-Moderatoren aktiv.",
    "revoke_confirm_text": "Möchtest du {{name}} die Tribunal-Moderationsrechte wirklich entziehen? Die Person kann danach keine guten Taten mehr prüfen."
  },
  "admin_karma": {
    "deduct_error": "Fehler beim Abziehen von Karma.",
    "award_error": "Fehler beim Gutschreiben von Karma.",
    "unknown_user": "Abenteurer",
    "pending_title": "Anfragen von Gilden-Admins",
    "title": "Karma-Verwaltung",
    "scope_hint": "Superadmins können das Karma aller Konten verwalten, Punkte abziehen oder gutschreiben und die vollständige Historie einsehen.",
    "filter_restricted": "XP-Abzug oder Sperre (≤ {{xp}})",
    "manage_btn": "Karma verwalten",
    "tier_xp_penalty": "Täglicher XP-Abzug",
    "tab_deduct": "Karma abziehen (Strafe)",
    "tab_award": "Karma gutschreiben (Bonus)",
    "tab_history": "Karma-Historie",
    "deduct_desc": "Verringert das Karma des Nutzers. Pflichtbegründung wird im Audit-Log vermerkt und per Benachrichtigung zugestellt.",
    "award_desc": "Erhöht das Karma des Nutzers bei besonderen Verdiensten oder Korrekturen.",
    "submit_deduct": "Karma abziehen & nutzende Person benachrichtigen",
    "submit_award": "Karma gutschreiben & nutzende Person benachrichtigen",
    "deduct_success": "Karma-Abzug erfolgreich gespeichert ({{delta}} Punkte).",
    "award_success": "Karma-Gutschrift erfolgreich gespeichert (+{{delta}} Punkte).",
    "history_empty": "Für dieses Konto sind keine Karma-Einträge vorhanden.",
    "history_title": "Audit-Log & Karma-Änderungen",
    "rules_summary_title": "Karma-Systemregeln",
    "rules_threshold": "Ab {{partner}} Partner-Sperre; {{xp}} bis {{xpEnd}} täglich {{percent}} % XP-Abzug; ab {{tribunal}} Tribunalentzug; ab {{suspension}} {{months}} Kalendermonat(e) Kontosperre",
    "rules_recovery": "Bestätigte gute Taten stellen schrittweise Karma wieder her"
  },
  "admin_settings": {
    "filter_heroic_actions": "Gute Taten & XP-Ranges",
    "filter_progression": "Ränge & Fortschritt"
  },
  "admin_events": {
    "form_ep_multi": "XP-Multiplikator",
    "multiplier_hint": "1 = kein XP-Bonus, 1,5 = +50 % XP, 2 = doppelte XP.",
    "rewards_hint": "Zusätzliches Event-Karma (0–100). Die tatsächliche Vergabe erfolgt bei der Prüfung der eingereichten Tat."
  },
  "access": {
    "unauthorized_back_dashboard": "Zum Abenteurer-Dashboard",
    "role_adventurer": "Abenteurer:in",
    "role_guildadmin": "Gilden-Admin"
  },
  "nav_cross": {
    "goto_adventurer_dashboard": "Zum Abenteurer-Dashboard",
    "tooltip_dual_role": "Du bist gleichzeitig Abenteurer"
  },
  "guild": {
    "public_about": "Über unsere Gilde",
    "public_navigation": "Gilde entdecken",
    "public_activity": "Gildenruhm & Aktivität",
    "already_in_guild_hint": "Du kannst nur einer Gilde angehören. Verlasse zuerst deine aktuelle Gilde.",
    "leave": "Gilde verlassen",
    "leave_confirm": "Möchtest du diese Gilde wirklich verlassen?",
    "disband_confirm": "Du bist das letzte Mitglied von {{name}}. Wenn du die Gilde verlässt, wird sie endgültig gelöscht. Möchtest du die Gilde wirklich auflösen?",
    "successor_warning": "Wähle vor deinem Austritt ein Mitglied als Nachfolger für die Gildenleitung. Die Gilde bleibt bestehen.",
    "own_house": "Dein Gildenhaus",
    "public_house": "Öffentliches Gildenhaus",
    "detail_description": "Eure gemeinsamen guten Taten hinterlassen Spuren. Mit wachsendem Gildenruhm wird eure Halle prächtiger.",
    "tab_news": "Gilden-Neuigkeiten",
    "tab_stammtisch": "Gilden-Stammtisch",
    "gildex_treasury": "Gildenschatzkammer",
    "unlocked_emotes": "Gilden-Emotes",
    "news_title": "Gilden-Neuigkeiten & Ankündigungen",
    "news_subtitle": "Offizielle System-Meldungen und administrative Aushänge für alle Gildenmitglieder.",
    "news_editor_title": "Neuen Gilden-Aushang verfassen",
    "news_title_placeholder": "z. B. Nächste Gildenversammlung und Gute-Taten-Fokus …",
    "news_content_placeholder": "Teile alle wichtigen Informationen mit deinen Gildenmitgliedern …",
    "news_loading": "Gilden-Neuigkeiten werden geladen …",
    "news_system_author": "System · Gildenzentrale",
    "no_news_desc": "Gilden-Admins können hier offizielle Aushänge verfassen.",
    "stammtisch_title": "Gilden-Stammtisch",
    "chat_empty_description": "Begrüße deine Gildenmitglieder oder tauscht euch über eure Abenteuer aus.",
    "chat_rank": "Rang {{rank}}",
    "chat_poll_question": "Stelle deiner Gilde eine Frage",
    "chat_action_failed": "Gildenchat konnte nicht aktualisiert werden.",
    "more_emotes_hint": "Stammtisch Plus im Gilden-Shop",
    "emote_cat_guild": "Gilde",
    "emote_cat_tavern": "Taverne",
    "admins_title": "Gilden-Admins:",
    "leader_title": "Gildenleiter:",
    "admin_badge": "Gilden-Admin",
    "promote_admin_title": "Zum Gilden-Admin befördern",
    "promote_confirm": "Möchtest du \"{{name}}\" zum Gilden-Admin befördern?",
    "promote_success": "\"{{name}}\" wurde erfolgreich zum Gilden-Admin befördert."
  },
  "notifications": {
    "heroic_action": {
      "approved_message": "Deine gute Tat ‚{{title}}‘ wurde freigegeben. +{{xp}} XP.",
      "review_assigned_title": "Neue Tribunal-Prüfung",
      "appeal_approved_message": "Die gute Tat wird in einer neuen, unabhängigen Tribunalrunde geprüft."
    },
    "group_action": {
      "invited_message": "Dein Gilden-Admin hat dich zu {{title}} eingeladen. Öffne die Gruppenaktionen deiner Gilde, um dich freiwillig anzumelden.",
      "announced_message": "Deine Gilde hat ‚{{title}}‘ ausgerufen. Die Anmeldung ist offen.",
      "approved_message": "‚{{title}}‘ wurde freigegeben. Dein Anteil: +{{xp}} XP."
    },
    "xp_audit": {
      "pending_title": "XP werden geprüft",
      "pending_message": "‚{{title}}‘ wurde freigegeben. Die XP werden wegen eines schnellen XP-Zuwachses bis zur Admin-Prüfung zurückgehalten.",
      "released_title": "XP freigegeben",
      "released_message": "Die Admin-Prüfung ist abgeschlossen. +{{xp}} XP wurden gutgeschrieben.",
      "rejected_title": "XP nicht freigegeben",
      "rejected_message": "Die Admin-Prüfung hat {{xp}} zurückgehaltene XP nicht freigegeben."
    },
    "guild_app_approved": {
      "title": "Gilden-Beitritt bestätigt!",
      "message": "Glückwunsch! Deine Beitrittsanfrage für die Gilde '{{guildName}}' wurde angenommen."
    },
    "guild_app_denied": {
      "title": "Gilden-Beitritt abgelehnt",
      "message": "Deine Beitrittsanfrage für die Gilde '{{guildName}}' wurde leider abgelehnt."
    },
    "promotion": {
      "title": "Beförderung zum Gilden-Admin!",
      "message": "Herzlichen Glückwunsch! Du wurdest zum Gilden-Admin befördert."
    }
  },
  "talents": {
    "branches": {
      "A": {
        "subtitle": "Kürzere Wartezeit, mehr Einreichungen und Gildex"
      },
      "B": {
        "subtitle": "Mehr Gesamt-XP, Kategorie-XP und Karma"
      },
      "C": {
        "subtitle": "Karma und Gruppenaktionen stärken"
      }
    },
    "skills": {
      "A_HEROIC_ACTION_SPONSOR": {
        "title": "Gilden-Förderer",
        "rank1_value": "+10 % Gildex",
        "rank2_value": "+20 % Gildex",
        "rank3_value": "+30 % Gildex",
        "rank1": "Stufe 1: Deine bestätigten guten Taten bringen deiner Gilde 10 % mehr Gildex.",
        "rank2": "Stufe 2: Deine bestätigten guten Taten bringen deiner Gilde 20 % mehr Gildex.",
        "rank3": "Stufe 3: Deine bestätigten guten Taten bringen deiner Gilde 30 % mehr Gildex."
      },
      "B_TREASURE_HUNTER": {
        "rank1_value": "+5 % Gesamt-XP",
        "rank2_value": "+10 % Gesamt-XP",
        "rank3_value": "+15 % Gesamt-XP",
        "rank1": "Stufe 1: Du erhältst 5 % mehr Gesamt-XP für bestätigte gute Taten.",
        "rank2": "Stufe 2: Du erhältst 10 % mehr Gesamt-XP für bestätigte gute Taten.",
        "rank3": "Stufe 3: Du erhältst 15 % mehr Gesamt-XP für bestätigte gute Taten."
      },
      "B_BARTERER": {
        "rank1_value": "+5 % Kategorie-XP",
        "rank2_value": "+10 % Kategorie-XP",
        "rank3_value": "+15 % Kategorie-XP",
        "rank1": "Stufe 1: Du erhältst 5 % mehr Kategorie-XP für bestätigte gute Taten.",
        "rank2": "Stufe 2: Du erhältst 10 % mehr Kategorie-XP für bestätigte gute Taten.",
        "rank3": "Stufe 3: Du erhältst 15 % mehr Kategorie-XP für bestätigte gute Taten."
      },
      "B_VERIFIED_PROOF": {
        "rank1_value": "+1 Karma",
        "rank2_value": "+2 Karma",
        "rank3_value": "+3 Karma",
        "rank1": "Stufe 1: Eine bestätigte gute Tat gibt dir 1 zusätzlichen Karma-Punkt.",
        "rank2": "Stufe 2: Eine bestätigte gute Tat gibt dir 2 zusätzliche Karma-Punkte.",
        "rank3": "Stufe 3: Eine bestätigte gute Tat gibt dir 3 zusätzliche Karma-Punkte."
      },
      "C_RESILIENCE": {
        "rank1_value": "bis zu +1 Karma",
        "rank2_value": "bis zu +2 Karma",
        "rank3_value": "bis zu +3 Karma",
        "rank1": "Stufe 1: Wenn dein Karma negativ ist, gewinnst du nach einer bestätigten guten Tat bis zu 1 zusätzliche Karma-Punkte zurück, höchstens bis 0.",
        "rank2": "Stufe 2: Wenn dein Karma negativ ist, gewinnst du nach einer bestätigten guten Tat bis zu 2 zusätzliche Karma-Punkte zurück, höchstens bis 0.",
        "rank3": "Stufe 3: Wenn dein Karma negativ ist, gewinnst du nach einer bestätigten guten Tat bis zu 3 zusätzliche Karma-Punkte zurück, höchstens bis 0."
      },
      "C_GROUP_MENTOR": {
        "rank3_title": "Legendärer Anführer",
        "rank1_value": "+5 % Gruppen-XP",
        "rank2_value": "+10 % Gruppen-XP",
        "rank3_value": "+15 % Gruppen-XP",
        "rank1": "Stufe 1: Dein Beitrag erhöht die XP einer bestätigten Gruppenaktion um 5 %.",
        "rank2": "Stufe 2: Dein Beitrag erhöht die XP einer bestätigten Gruppenaktion um 10 %.",
        "rank3": "Stufe 3: Dein Beitrag erhöht die XP einer bestätigten Gruppenaktion um 15 %."
      },
      "C_GUILD_BENEFACTOR": {
        "rank1_value": "+1 Karma",
        "rank2_value": "+2 Karma",
        "rank3_value": "+3 Karma",
        "rank1": "Stufe 1: Für eine bestätigte Gruppenaktion erhältst du 1 zusätzlichen Karma-Punkt.",
        "rank2": "Stufe 2: Für eine bestätigte Gruppenaktion erhältst du 2 zusätzliche Karma-Punkte.",
        "rank3": "Stufe 3: Für eine bestätigte Gruppenaktion erhältst du 3 zusätzliche Karma-Punkte."
      }
    },
    "stats": {
      "xp_bonus": {
        "label": "Gesamt-XP",
        "description": "Zusätzliche Gesamt-XP für bestätigte Einzelaktionen. Der Klassenbonus gilt in der passenden Kategorie."
      },
      "cat_xp_bonus": {
        "label": "Kategorie-XP",
        "description": "Zusätzliche XP in der Kategorie deiner bestätigten Einzelaktion. Allgemeine XP-Boni zählen ebenfalls."
      },
      "gildex": {
        "label": "Gildex",
        "description": "Deine Gilde erhält für bestätigte Einzelaktionen zusätzlich Gildex. Deine eigenen XP bleiben vollständig erhalten.",
        "base_xp": "{{percent}}% der Basis-XP"
      },
      "karma_rec": {
        "label": "Karma-Erholung",
        "description": "Bei negativem Karma bekommst du nach bestätigten guten Taten zusätzliche Punkte zurück, höchstens bis 0.",
        "talent": "+{{value}} Karma (max +3, nur bei negativem Karma)"
      },
      "party_ep": {
        "label": "Gruppen XP",
        "description": "Bestätigte Gruppenaktionen bringen mehr XP. Der stärkste Klassenbonus zählt einmal; Talentboni kommen hinzu."
      },
      "talent_rank": "Talentstufe {{rank}}/3",
      "talent": "Talent",
      "class": "Klasse",
      "class_bonus": "Klassenbonus",
      "talent_points": "Talentpunkte",
      "honor_heading": "Ehre & Karma",
      "xp_passive": "+{{percent}}% (max +10%: Gilde +5%, Ausbau +5%)",
      "karma_value": "+{{value}} Karma",
      "karma_bonus": {
        "label": "Karma-Bonus",
        "description": "So viel zusätzliches Karma erhältst du für eine bestätigte gute Tat. Für den Gesamtwert gilt die aktuelle Systemgrenze.",
        "base": "0 zusätzliches Karma",
        "talent": "+{{value}} Karma (max +3)"
      },
      "group_karma": {
        "label": "Gruppen-Karma",
        "description": "So viel zusätzliches Karma erhältst du für bestätigte Gruppenaktionen.",
        "base": "0 zusätzliches Gruppen-Karma",
        "talent": "+{{value}} Karma (max +3)"
      }
    },
    "ui": {
      "xp_progress": "XP {{current}} / {{required}}",
      "xp_progress_aria": "Fortschritt zum nächsten Talentpunkt in XP",
      "all_points_reached": "Alle Talentpunkte erreicht",
      "upgrade_success": "Talent-Stufe erfolgreich aufgewertet!",
      "upgrade_failed": "Talent konnte nicht aufgewertet werden.",
      "tier_requirement": "Vorheriges Talent auf Stufe 2",
      "prereq_required": "Bringe zuerst das vorherige Talent auf Stufe 2.",
      "points_required": "Du brauchst einen verfügbaren Talentpunkt.",
      "footer_tip": "Jede neue Talentstufe verbessert deinen Bonus dauerhaft.",
      "loading": "Talentbäume werden geladen...",
      "error_load": "Fehler beim Laden der Talentbäume.",
      "origin_title": "Deine Talente",
      "skill_tree_nav": "Wähle ein Talent und sieh dir seine Boni an.",
      "progression_path": "Talentstufen",
      "select_skill_hint": "Wähle ein Talent, um seinen Bonus und die nächste Stufe zu sehen."
    },
    "tree": {
      "rank": "Rang {{rank}}",
      "requires_rank": "Vorheriges Talent: Stufe {{rank}}"
    },
    "title": "Deine Talente",
    "description": "Für erreichte Level erhältst du Talentpunkte. Damit kannst du Boni für Erfahrung, gemeinsame Aktionen und deine nächsten Einreichungen freischalten.",
    "path_subtitles": {
      "A": "Einreichungen/Gildex",
      "B": "XP und Karma",
      "C": "Karma und Gruppe"
    }
  },
  "categories": {
    "ENTERTAINMENT_GASTRO": "Entertainment & Gastro",
    "LOGISTICS_RETAIL": "Logistik & Handel",
    "TECH_EDUCATION": "Tech & Bildung",
    "HEALTH_WELLNESS": "Gesundheit & Wellness",
    "MOBILITY_OUTDOOR": "Mobilität & Outdoor",
    "FOOD_GROCERIES": "Lebensmittel & Ernährung",
    "HARDWARE_FITNESS": "Fitness & Ausrüstung"
  },
  "classes": {
    "roles": {
      "SCOUT": "Mobilität & Outdoor",
      "MEDIC": "Gesundheit & Wellness",
      "SOCIAL": "Entertainment & Gastro",
      "TANK": "Fitness & Ausrüstung",
      "TECH": "Tech & Bildung",
      "NUTRITION": "Lebensmittel & Ernährung",
      "LOGISTICS": "Logistik & Handel"
    },
    "perks": {
      "SCOUT": "Bei bestätigten guten Taten in Mobilität & Outdoor erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Du musst zwischen zwei Einreichungen 10 % kürzer warten.",
      "MEDIC": "Bei bestätigten guten Taten in Gesundheit & Wellness erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Solange dein Karma negativ ist, erhältst du für jede bestätigte gute Tat einen zusätzlichen Karma-Punkt zurück, höchstens bis 0.",
      "SOCIAL": "Bei bestätigten guten Taten in Entertainment & Gastro erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Bei bestätigten Gruppenaktionen gibt es 10 % mehr XP für die Gruppe. Auch mit mehreren Barden gilt der Bonus nur einmal.",
      "TANK": "Bei bestätigten guten Taten in Fitness & Ausrüstung erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Du kannst eine weitere gute Tat gleichzeitig einreichen.",
      "ENVIRONMENT": "Bei bestätigten guten Taten in Umwelt & Natur erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Deine bestätigten Einzelaktionen bringen deiner Gilde 20 % mehr Gildex.",
      "TECH": "Bei bestätigten guten Taten in Tech & Bildung erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Bei bestätigten guten Taten außerhalb von Tech & Bildung erhältst du 10 % mehr XP in der jeweiligen Kategorie.",
      "CRAFTER": "Bei bestätigten guten Taten in Handwerk & Reparatur erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Du kannst eine abgelehnte eigene Einzelaktion einmal überarbeiten und erneut prüfen lassen.",
      "NUTRITION": "Bei bestätigten guten Taten in Lebensmittel & Ernährung erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Einmal pro Kalenderwoche kannst du vor einer Einzelaktion ein kostenloses Erfahrungselixier aktivieren. Wird die Tat bestätigt, erhältst du 25 % mehr Gesamt- und Kategorie-XP.",
      "LOGISTICS": "Bei bestätigten guten Taten in Logistik & Handel erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Einmal pro Kalenderwoche kannst du die Wartezeit bis zur nächsten Einreichung überspringen. Ein freier Platz ist weiterhin nötig.",
      "GUARDIAN": "Bei bestätigten guten Taten in der Kategorie Soziales & Gemeinschaft erhältst du 20 % mehr Gesamt-XP und Kategorie-XP. Für jede bestätigte gute Tat erhältst du einen zusätzlichen Karma-Punkt, auch bei Gruppenaktionen.",
      "default": "Spezialfähigkeit der Hauptklasse"
    }
  },
  "perks": {
    "titles": {
      "CLASS_V2_GUARDIAN_ABILITY": "Zusätzliches Karma",
      "CLASS_V2_NUTRITION_ABILITY": "Erfahrungselixier",
      "CLASS_V2_TECH_ABILITY": "Mehr XP in anderen Kategorien",
      "CLASS_V2_ENVIRONMENT_ABILITY": "Mehr Gildex für die Gilde",
      "CLASS_V2_MEDIC_ABILITY": "Karma schneller erholen"
    },
    "CLASS_V2_SCOUT_CATEGORY": "Bei bestätigten guten Taten in Mobilität & Outdoor erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_TANK_CATEGORY": "Bei bestätigten guten Taten in Fitness & Ausrüstung erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_GUARDIAN_CATEGORY": "Bei bestätigten guten Taten in der Kategorie Soziales & Gemeinschaft erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_GUARDIAN_ABILITY": "Für jede bestätigte gute Tat erhältst du einen zusätzlichen Karma-Punkt, auch bei Gruppenaktionen.",
    "CLASS_V2_CRAFTER_CATEGORY": "Bei bestätigten guten Taten in Handwerk & Reparatur erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_SOCIAL_CATEGORY": "Bei bestätigten guten Taten in Entertainment & Gastro erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_SOCIAL_ABILITY": "Bei bestätigten Gruppenaktionen gibt es 10 % mehr XP für die Gruppe. Auch mit mehreren Barden gilt der Bonus nur einmal.",
    "CLASS_V2_LOGISTICS_CATEGORY": "Bei bestätigten guten Taten in Logistik & Handel erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_NUTRITION_CATEGORY": "Bei bestätigten guten Taten in Lebensmittel & Ernährung erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_NUTRITION_ABILITY": "Einmal pro Kalenderwoche kannst du vor einer Einzelaktion ein kostenloses Erfahrungselixier aktivieren. Wird die Tat bestätigt, erhältst du 25 % mehr Gesamt- und Kategorie-XP.",
    "CLASS_V2_TECH_CATEGORY": "Bei bestätigten guten Taten in Tech & Bildung erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_TECH_ABILITY": "Bei bestätigten guten Taten außerhalb von Tech & Bildung erhältst du 10 % mehr XP in der jeweiligen Kategorie.",
    "CLASS_V2_ENVIRONMENT_CATEGORY": "Bei bestätigten guten Taten in Umwelt & Natur erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_ENVIRONMENT_ABILITY": "Deine bestätigten Einzelaktionen bringen deiner Gilde 20 % mehr Gildex.",
    "CLASS_V2_MEDIC_CATEGORY": "Bei bestätigten guten Taten in Gesundheit & Wellness erhältst du 20 % mehr Gesamt-XP und Kategorie-XP.",
    "CLASS_V2_MEDIC_ABILITY": "Solange dein Karma negativ ist, erhältst du für jede bestätigte gute Tat einen zusätzlichen Karma-Punkt zurück, höchstens bis 0."
  },
  "api": {
    "guild_unlock": {
      "already_unlocked": "Diese Gilden-Freischaltung ist bereits aktiv.",
      "insufficient_gildex": "Die Gildenschatzkammer enthält nicht genügend Gildex für diese Freischaltung.",
      "requires_previous_boost": "Schalte zuerst die vorherige XP-Boost-Stufe frei."
    },
    "messages": {
      "guild_statistics_members_only": "Nur Mitglieder dieser Gilde haben Zugriff auf die Gildenstatistik.",
      "guild_founding_rank_required": "Für die Gildengründung benötigst du mindestens Rang {{rank}}.",
      "guild_founding_actions_required": "Für die Gildengründung benötigst du mindestens {{count}} bestätigte gute Taten.",
      "guild_founding_karma_required": "Für die Gildengründung benötigst du mindestens {{karma}} Karma.",
      "guild_founding_cooldown": "Nach dem Ende deiner letzten Gildenleitung musst du {{days}} Tage warten, bevor du erneut eine Gilde gründen kannst.",
      "settings_rank_requirement_invalid": "Der Mindest-Rang muss F, E, D, C, B, A oder S sein.",
      "settings_karma_requirement_invalid": "Das Mindest-Karma muss innerhalb der aktuellen Karma-Grenzen und oberhalb der Tribunal-Entzugsgrenze liegen.",
      "settings_karma_threshold_order_invalid": "Die Karma-Schwellen müssen in gültiger Reihenfolge liegen (Sperre, Tribunalentzug, XP-Abzug, Partner-Sperre, positive Stufen).",
      "settings_karma_xp_penalty_invalid": "Der tägliche Karma-XP-Abzug muss zwischen 0 und 100 Prozent liegen.",
      "guild_applicant_unavailable": "Der Bewerber kann keiner Gilde mehr beitreten.",
      "heroic_xp_audit_pending": "Zuerst muss die ausstehende XP-Prüfung entschieden werden.",
      "heroic_xp_balance_mismatch": "Die XP-Buchungen stimmen nicht mit dem aktuellen Guthaben überein. Die Einreichung wurde nicht gelöscht.",
      "heroic_recalculate_admin_only": "Nur aktive System-Admins dürfen XP neu berechnen.",
      "heroic_tribunal_assessment_missing": "Die ursprüngliche Tribunal-Einstufung fehlt.",
      "heroic_xp_ledger_missing": "Für diese Einreichung fehlt die ursprüngliche XP-Buchung.",
      "heroic_xp_participants_mismatch": "Die XP-Buchungen passen nicht mehr zu den bestätigten Teilnehmern.",
      "heroic_xp_negative_balance": "Die XP-Korrektur würde einen negativen Kontostand erzeugen.",
      "heroic_return_reviewer_only": "Nur aktive Tribunal-Moderatoren oder System-Admins dürfen Einreichungen zurückschicken.",
      "class_change_unavailable": "Der einmalige Klassenwechsel ist nicht mehr verfügbar oder für dieses Konto nicht erlaubt.",
      "class_change_same": "Bitte wähle eine andere Klasse. Dein einmaliger Wechsel wurde nicht verbraucht.",
      "class_change_invalid": "Diese Klasse ist nicht verfügbar. Dein einmaliger Wechsel wurde nicht verbraucht.",
      "benutzer_erfolgreich_aus_der_g_38": "Benutzer erfolgreich aus der Gilde verbannt und gesperrt.",
      "gilden_sperre_erfolgreich_aufg_40": "Gilden-Sperre erfolgreich aufgehoben.",
      "gilden_wappen_erfolgreich_hochgeladen": "Gilden-Wappen erfolgreich hochgeladen und aktualisiert.",
      "gildenname_ist_erforderlich_un_23": "Gildenname ist erforderlich und darf max. 60 Zeichen haben.",
      "gildenstandort_breiten_und_l_n_25": "Gildenstandort (Breiten- und Längengrad) ist erforderlich.",
      "heldenklasse_erfolgreich_archi_8": "Heldenklasse erfolgreich archiviert (Soft Delete).",
      "heldenklasse_erfolgreich_wiede_9": "Heldenklasse erfolgreich wiederhergestellt.",
      "keine_aktive_gilden_sperre_f_r_39": "Keine aktive Gilden-Sperre für diesen Benutzer gefunden.",
      "klassen_perk_erfolgreich_archi_12": "Klassen-Perk erfolgreich archiviert (Soft Delete).",
      "klassen_perk_erfolgreich_wiede_13": "Klassen-Perk erfolgreich wiederhergestellt.",
      "mitglied_erfolgreich_aus_der_g_36": "Mitglied erfolgreich aus der Gilde entfernt.",
      "mitglied_erfolgreich_zum_gilde_46": "Mitglied erfolgreich zum Gilden-Admin befördert.",
      "mitglied_nicht_in_dieser_gilde_35": "Mitglied nicht in dieser Gilde gefunden.",
      "mitglied_nicht_in_dieser_gilde_45": "Mitglied nicht in dieser Gilde gefunden.",
      "nur_gilden_administratoren_d_31": "Nur Gilden-Administratoren dürfen Beitrittsanträge ansehen.",
      "nur_gilden_administratoren_d_32": "Nur Gilden-Administratoren dürfen Beitrittsanträge bearbeiten.",
      "nur_verifizierte_mitglieder_di_31": "Nur verifizierte Mitglieder dieser Gilde haben Zugriff auf den Gildenchat.",
      "nur_verifizierte_mitglieder_di_32": "Nur verifizierte Mitglieder dieser Gilde dürfen Nachrichten im Gildenchat verfassen.",
      "nur_verifizierte_mitglieder_di_33": "Nur verifizierte Mitglieder dieser Gilde haben Zugriff auf die Gilden-Neuigkeiten.",
      "talent_erfolgreich_freigeschaltet": "Talent erfolgreich freigeschaltet!",
      "guild_successor_required": "Ernenne zuerst ein anderes Mitglied zum Gildenleiter, bevor du die Gilde verlässt.",
      "guild_disband_confirmation_required": "Bestätige die Auflösung der Gilde, bevor du als letztes Mitglied austrittst.",
      "heroic_base_xp_range": "Die Basis-XP müssen für diese Einstufung zwischen {{minimum}} und {{maximum}} liegen.",
      "heroic_category_xp_range": "Die Kategorie-XP müssen für diese Einstufung zwischen {{minimum}} und {{maximum}} liegen.",
      "class_perk_hero_class_not_found": "Die Heldenklasse wurde nicht gefunden.",
      "class_perk_not_found": "Der Klassen-Perk wurde nicht gefunden.",
      "admin_delta_range": "Die Anpassung muss zwischen −100 und +100 liegen; für den Karmawert gelten die aktuellen Systemgrenzen.",
      "heroic_group_resubmit_in_guild": "Zurückgezogene Gruppenaktionen müssen über das Gildenhaus neu angelegt werden.",
      "heroic_review_moderator_only": "Nur Tribunal-Moderatoren dürfen offene gute Taten sehen.",
      "heroic_reviewer_role_required": "Nur freigegebene Tribunal-Moderatoren oder Admins dürfen prüfen.",
      "heroic_appeal_reviewer_conflict": "Wer über den Einspruch entschieden hat, darf die neue Tribunalrunde nicht selbst prüfen.",
      "heroic_review_guild_conflict": "Mitglieder derselben Gilde dürfen gute Taten anderer Gildenmitglieder nicht prüfen.",
      "heroic_review_same_player_cooldown": "Anti-Cheat: Aus Sicherheitsgründen musst du nach einer Prüfung desselben Helden eine Abklingzeit abwarten.",
      "heroic_review_other_players_first": "Anti-Cheat: Du musst erst gute Taten anderer Helden prüfen, bevor du diesen Helden erneut prüfen kannst.",
      "heroic_first_review_xp_required": "Die erste Prüfung muss Basis- und Kategorie-XP festlegen – auch bei einer Ablehnung.",
      "heroic_moderator_rank_required": "Dein Rang liegt unter der aktuellen Mindestgrenze für die Tribunalbewerbung.",
      "heroic_moderator_karma_required": "Dein Karma liegt unter der aktuellen Mindestgrenze für die Tribunalbewerbung.",
      "heroic_already_moderator": "Du bist bereits Tribunal-Moderator.",
      "heroic_appeal_guild_conflict": "Mitglieder derselben Gilde dürfen keine Einsprüche von Gildenmitgliedern entscheiden.",
      "heroic_adventurers_only": "Nur Abenteurer dürfen diese Funktion verwenden.",
      "partner_qr_requires_approved_hero": "Nur freigeschaltete Abenteurer können einen QR-Pass generieren.",
      "direct_chat_contact_restricted": "Spam-Schutz: Du darfst nur mit Benutzern chatten, die in deiner Gilde sind oder bei denen eine Gilden-Bewerbung aussteht.",
      "settings_xp_range_key_invalid": "Ungültiger Schlüssel für eine Gute-Taten-XP-Range.",
      "settings_xp_range_value_invalid": "XP-Ranges müssen ganze Zahlen zwischen 0 und 100000 sein.",
      "settings_xp_range_order_invalid": "Die XP-Untergrenze darf nicht über der Obergrenze liegen.",
      "settings_gildex_rate_invalid": "Die Gildex-Rate muss zwischen 0 und 100 Prozent liegen.",
      "talent_not_found": "Talent existiert nicht im System.",
      "talent_max_level": "Dieses Talent hat bereits die Maximalstufe 3/3 erreicht.",
      "talent_no_points": "Du hast keine verfügbaren Talentpunkte mehr.",
      "guild_chat_locked": "Schalte zuerst den Gilden-Stammtisch im Gildex frei.",
      "guild_chat_members_only": "Nur Gildenmitglieder können den Gildenchat nutzen.",
      "guild_emotes_locked": "Schalte zuerst den Gilden-Stammtisch und das Emote-Paket frei.",
      "guild_pin_admin_only": "Nur Gilden-Admins können Nachrichten anheften.",
      "guild_news_title_required": "Gib einen Titel für den Gilden-Aushang ein.",
      "guild_news_content_required": "Gib einen Inhalt für den Gilden-Aushang ein.",
      "guild_news_admin_only": "Nur Gilden-Admins können Aushänge erstellen.",
      "guild_news_remove_admin_only": "Nur Gilden-Admins können Aushänge entfernen.",
      "guild_cannot_kick_self": "Du kannst dich nicht selbst aus der Gilde entfernen.",
      "guild_kick_admin_only": "Nur Gilden-Admins können Mitglieder entfernen.",
      "guild_cannot_kick_system_admin": "System-Admins können nicht aus einer Gilde entfernt werden.",
      "guild_cannot_ban_self": "Du kannst dich nicht selbst aus der Gilde bannen.",
      "guild_ban_admin_only": "Nur Gilden-Admins können Mitglieder bannen.",
      "guild_cannot_ban_system_admin": "System-Admins können nicht aus einer Gilde gebannt werden.",
      "guild_unban_admin_only": "Nur Gilden-Admins können Sperren aufheben.",
      "guild_bans_admin_only": "Nur Gilden-Admins können gesperrte Mitglieder ansehen.",
      "guild_edit_admin_only": "Nur Gilden-Admins können Gildendaten bearbeiten.",
      "guild_not_found": "Die Gilde wurde nicht gefunden.",
      "guild_emblem_admin_only": "Nur Gilden-Admins können das Wappen ändern.",
      "guild_emblem_too_large": "Die Wappendatei darf höchstens 5 MB groß sein.",
      "guild_not_member": "Du bist kein Mitglied dieser Gilde.",
      "guild_promote_admin_only": "Nur Gilden-Admins können Mitglieder befördern.",
      "guild_leadership_transfer_invalid": "Diese Übertragung der Gildenleitung ist nicht möglich.",
      "guild_deputy_locked": "Schalte weitere Gilden-Admins zuerst im Gildex frei.",
      "guild_unlock_not_found": "Die Gilden-Freischaltung wurde nicht gefunden.",
      "guild_gildex_admin_only": "Nur Gilden-Admins können Gildex ausgeben.",
      "guild_treasury_members_only": "Nur Gildenmitglieder können die Schatzkammer ansehen.",
      "group_action_members_only": "Nur Mitglieder dieser Gilde haben Zugriff auf diese Aktion.",
      "group_action_active_members_only": "Nur aktive Gildenmitglieder können teilnehmen.",
      "group_action_admin_only": "Nur Gilden-Admins können Gruppenaktionen verwalten.",
      "group_action_locked": "Schalte Gruppenaktionen zuerst im Gildex frei.",
      "guild_already_founded": "Du hast bereits eine Gilde gegründet und kannst keine weitere gründen.",
      "guild_membership_exists": "Du bist bereits Mitglied einer Gilde. Verlasse sie, bevor du eine neue gründest.",
      "guild_already_member": "Du bist bereits Mitglied einer Gilde.",
      "guild_name_taken": "Dieser Gildenname ist bereits vergeben. Wähle einen anderen Namen.",
      "partner_contact_required": "Bitte gib einen Kontakt für Abenteurer mit höchstens 250 Zeichen an.",
      "karma_minimum": "Der minimale Karma-Wert ist bereits erreicht.",
      "karma_maximum": "Der maximale Karma-Wert ist bereits erreicht.",
      "account_suspended_karma": "Dieses Konto wurde wegen Karma {{karma}} gesperrt (Sperrgrenze: {{threshold}}). Die temporäre Sperre endet am {{until}}.",
      "karma_partner_restricted": "Partnervorteile sind bei gesperrten Konten oder negativem Karma nicht verfügbar.",
      "karma_minimum_not_met": "Dein Karma liegt unter dem Mindestwert für dieses Angebot.",
      "class_skip_merchant_only": "Nur Händler können Gute Kontakte einsetzen.",
      "heroic_cooldown_slot_unavailable": "Dieser Cooldown-Slot ist nicht mehr aktiv. Bitte die Seite aktualisieren.",
      "class_elixir_unavailable": "Erfahrungselixier ist diese Woche nicht verfügbar.",
      "ungueltige_rolle": "Registrierungen sind nur als Abenteurer oder Partner möglich.",
      "ungueltige_heldenklasse": "Die gewählte Heldenklasse ist ungültig.",
      "invalid_gildex_price": "Der Gildex-Preis muss eine nichtnegative ganze Zahl sein.",
      "account_successor_required": "Übertrage vor der Kontolöschung die Gildenleitung an ein anderes Mitglied.",
      "group_xp_allocation_missing": "Bitte lege die XP-Verteilung fest.",
      "group_xp_allocation_incomplete": "Die gespeicherte XP-Verteilung ist unvollständig.",
      "group_xp_allocation_approval": "Bitte bestätige ausdrücklich die XP-Verteilung des Organisators.",
      "group_xp_allocation_stale": "Die Prüfrunde hat sich geändert. Lade die Aktion erneut und prüfe die aktuelle XP-Verteilung."
    }
  },
  "faq_page": {
    "subtitle": "Gute Taten, Tribunal, XP, Gilden, Partner und Datenschutz",
    "sections": [
      [
        "Gute Taten & XP",
        [
          [
            "Wie funktioniert Goodvale?",
            "Du meldest eine tatsächlich ausgeführte gute Tat selbst, beschreibst sie und reichst – außer bei zulässiger Selbstauskunft – einen verschlüsselten Beweis ein. Das Tribunal prüft unabhängig. Erst die endgültige Bestätigung schreibt globale XP und Kategorie-XP gut."
          ],
          [
            "Wie viele XP sind angemessen?",
            "Die Admin-Einstellungen enthalten sechs Einzelbänder und acht separate Gruppenbänder. Die Gruppenpools reichen aktuell von {{groupBand1}} XP in Band 1 bis {{groupBand8}} XP in Band 8, jeweils vor Boni und Aufteilung. Die folgenden Beispiele zeigen Einzelwerte. Zeit und Einsatz umfassen Zeit, Belastung und Verantwortung; Planung und Abstimmung umfassen Planung, Abstimmung und Beteiligte. Moderatoren müssen innerhalb der daraus berechneten Range bleiben.\n\nRichtwerte & Beispiele:\n• {{xpBand1}} XP: Umweltmeldung oder kleine konkrete Unterstützung (gering / einfach)\n• {{xpBand2}} XP: Sack Müll sammeln, Einkaufshilfe oder 1 Stunde Nachhilfe (mittel / einfach)\n• {{xpBand3}} XP: Koordinierter Workshop, Hilfsgütersortierung (mittel–hoch / koordiniert)\n• {{xpBand4}} XP: Reparatur-Nachmittag oder kleinere Sammelaktion (hoch / komplex)\n• {{xpBand5}} XP: Größere Aufräumaktion mit Team und Entsorgung (außergewöhnlich / koordiniert)\n• {{xpBand6}} XP: Mehrwöchige Patenschaft oder dauerhaftes Hilfsnetzwerk (außergewöhnlich / komplex)\n\nBei Spenden zählt der eigene Aufwand, nie der Geld- oder Warenwert."
          ],
          [
            "Was passiert mit globalen und Kategorie-XP?",
            "Bestätigte XP erhöhen dein Charakter-Level und deinen Rang. Kategorie-XP erhöhen zusätzlich dein Level in der passenden Kategorie. Partner können Angebote an folgende Bedingungen knüpfen:\n• Rang oder Charakter-Level\n• Gesamt-XP oder Kategorie-XP\n• Bestimmte verifizierte Systemaktionen\n\nXP werden bei Partnerangeboten nicht ausgegeben oder verbraucht."
          ],
          [
            "Wie erhalte und verwende ich Kategorie-Titel und Abzeichen?",
            "In jeder der zehn Kategorien schaltest du bei Level 2, 5, 10, 30, 50, 70 und 100 jeweils einen Titel und ein Abzeichen frei. Dafür brauchst du 200, 1.250, 5.000, 45.000, 125.000, 245.000 beziehungsweise 500.000 Kategorie-XP. Im Profil kannst du aus allen aktuell freigeschalteten Titeln genau einen auswählen oder keinen anzeigen. Bei einer bestätigten guten Tat zeigt das Bestätigungs-Popup neu erreichte Meilensteine mit Abzeichen und Titel. Titel und Abzeichen sind kosmetisch und geben keine fachlichen Befugnisse. Wird eine XP-Gutschrift rückgängig gemacht, können dadurch erreichte Meilensteine wieder gesperrt werden."
          ],
          [
            "Was sind Cooldown und parallele Einreichungen?",
            "Einzelaktionen und aktive Gruppenanmeldungen teilen sich deine Slots. Offene Aktionen und laufende Wartezeiten belegen jeweils einen Slot. Rückzug oder Abbruch geben den Slot sofort frei.\n\nBei Einzelaktionen beginnt die Wartezeit mit der XP-Gutschrift. Bei Gruppenaktionen zählt sie ab der Anmeldung und startet bei der Gutschrift nicht erneut. Unter „Meine Slots“ siehst du deine aktuelle Belegung und verbleibende Wartezeiten."
          ],
          [
            "Wie funktioniert der XP-Boost?",
            "Alchemisten können vor einer Einzel-Einreichung einmal pro Kalenderwoche ein kostenloses Erfahrungselixier aktivieren:\n• +25 % Gesamt- und Kategorie-XP bei Bestätigung\n• Die Ladung wird bei Einreichung verbraucht (auch bei Ablehnung oder Rückzug)\n• Der Wochenwechsel erfolgt montags um 00:00 UTC"
          ],
          [
            "Kann ich eine gute Tat zurückziehen?",
            "Ja. Unter deinen Einreichungen kannst du eine eigene gute Tat mit dem Status „In Prüfung“ zurückziehen:\n• Laufende Prüfaufträge werden sofort beendet.\n• Es gibt keine Belohnung und keinen Karma-Abzug.\n• Bereits bestätigte oder endgültig abgelehnte gute Taten können nicht zurückgezogen werden.\n• Bei Gruppenaktionen wird die gesamte Gruppenaktion abgebrochen."
          ]
        ]
      ],
      [
        "Tribunal & Einspruch",
        [
          [
            "Wer darf moderieren?",
            "Ab Rang {{tribunalRank}} und {{tribunalMinimum}} Karma können sich Abenteurer als Tribunal-Moderatoren bewerben. Nach Freigabe durch einen Admin können sie Fälle prüfen. Ausgeschlossen sind:\n• Eigene Einreichungen oder gute Taten mit eigener Teilnahme\n• Einreichungen von Mitgliedern der eigenen Gilde\n• Neue Prüfrunden nach einem selbst entschiedenen Einspruch"
          ],
          [
            "Gibt es Anti-Cheat-Schutzmaßnahmen bei der Moderation?",
            "Ja. Um Betrug und gegenseitige Freigaben zu verhindern, greifen automatische Anti-Cheat-Regeln:\n• Selbstprüfungsverbot & Gilden-Mitgliedersperre\n• Automatische Abklingzeiten für wiederholte Nutzer-Paarungen\n• Pflicht zur Prüfung anderer Nutzer (Durchmischungsregel)\n\nDadurch kann es vorkommen, dass manche gute Taten erst zeitversetzt oder nach der Prüfung anderer Einreichungen in der Übersicht erscheinen."
          ],
          [
            "Wie viele Moderatoren prüfen?",
            "Die erste zugewiesene Prüfung legt Zeit und Einsatz, Planung und Abstimmung sowie Basis-XP fest. Die Anzahl erforderlicher Prüfungen richtet sich nach den XP-Schwellen:\n• Einzelprüfung: Bei kleineren guten Taten\n• Mehrfachprüfung: Bei mittleren bis großen guten Taten (Quorum entscheidet per Mehrheit)\n• Admin-Prüfung: Bei sehr hohen XP-Werten muss mindestens ein System-Admin prüfen"
          ],
          [
            "Reicht eine Ablehnung?",
            "Nur wenn für die festgelegten XP genau eine Prüfung erforderlich ist. Bei Mehrfachprüfungen entscheidet das Quorum per Mehrheit. Ein 1:1-Patt führt automatisch zu einer dritten unabhängigen Tie-Break-Prüfung. Einreichende sehen nur den laufenden Status und das Endergebnis."
          ],
          [
            "Wie funktioniert ein Einspruch?",
            "Nach einer endgültigen Ablehnung kannst du innerhalb der Frist einen begründeten Einspruch einlegen:\n• Ein System-Admin entscheidet, ob eine neue unabhängige Prüfrunde eröffnet wird.\n• Der entscheidende Admin darf diese Runde nicht selbst prüfen.\n• Der ursprüngliche Beweis muss weiter vorhanden sein."
          ],
          [
            "Was unterscheidet den Einspruch von der zweiten Prüfungschance des Schmieds?",
            "Mit einem Einspruch fechtest du die Ablehnung an. Er ist innerhalb der eingestellten Frist möglich und muss begründet werden. Ein System-Admin entscheidet, ob eine neue Prüfrunde beginnt; eine Annahme bestätigt die gute Tat noch nicht.\n\nMit der Klassenfähigkeit „Zweite Prüfungschance“ kannst du als Schmied eine eigene abgelehnte Einzelaktion einmal überarbeiten und direkt erneut zur Prüfung einreichen. Dafür musst du die Beschreibung ändern oder einen neuen Nachweis hochladen und einen freien Einreichungsslot haben. Diese Fähigkeit ist nicht an die Einspruchsfrist gebunden. Während ein Einspruch läuft, kannst du sie für dieselbe Tat nicht nutzen."
          ]
        ]
      ],
      [
        "Beweise & Datenschutz",
        [
          [
            "Welche Kurzvideos kann ich als Nachweis einreichen?",
            "Du kannst Kurzvideos (MP4, max. 10 Sekunden, 10 MB) in drei Kategorien einreichen:\n• Tätigkeit: Zeigt deinen Beitrag während der Ausführung\n• Vorher: Zeigt den Ausgangszustand vor Beginn\n• Nachher: Zeigt das Ergebnis aus gleicher Perspektive"
          ],
          [
            "Werden Vorher-/Nachher-Videos schneller geprüft?",
            "Zwei eindeutige Videos mit „Vorher“ und „Nachher“ erleichtern die Prüfung und können die Verifikation beschleunigen. Eine automatische Bestätigung ist damit jedoch nicht verbunden. Achte darauf, fremde Gesichter oder private Daten zu vermeiden."
          ],
          [
            "Wie werden Beweise geschützt?",
            "Beweise werden sicher geschützt:\n• Verschlüsselte Speicherung außerhalb des Webverzeichnisses\n• Prüfung von Dateigröße, Typ, Dateisignatur und Hashes\n• Speicherung von Zeitpunkt und Version der Datenschutzbestätigung\n• Audit-Protokollierung jedes Lesezugriffs"
          ],
          [
            "Wer darf Beweise sehen?",
            "Beweise sind ausschließlich sichtbar für:\n• Dich selbst als einreichende Person\n• Den aktuell zugewiesenen Tribunal-Moderator\n• Berechtigte System-Admins"
          ],
          [
            "Wie lange bleiben Beweise gespeichert?",
            "Nach der endgültigen Entscheidung wird ein Ablaufdatum gesetzt. Nach Ablauf der Aufbewahrungsfrist entfernt ein Hintergrunddienst Datei und Datensatz automatisch."
          ],
          [
            "Welche Rechte habe ich?",
            "Im Profil kannst du:\n• Eine maschinenlesbare Kopie deiner Daten herunterladen\n• Dein Konto anonymisieren (Kontaktdaten und Beweise werden entfernt, Login gesperrt)"
          ]
        ]
      ],
      [
        "Gilden & Gruppen",
        [
          [
            "Wann kann ich eine eigene Gilde gründen?",
            "Die World Guild ist deine erste Anlaufstelle. Dort kannst du Goodvale kennenlernen und durch bestätigte gute Taten Erfahrung sammeln. Für eine eigene Gilde brauchst du mindestens Rang {{guildRank}}, {{guildActions}} bestätigte eigene gute Taten und {{guildKarma}} Karma. Du darfst aktuell keiner Gilde angehören. Nach Auflösung oder Übergabe deiner eigenen Gilde musst du {{guildCooldown}} Tage warten, bevor du erneut gründest. Superadmins können diese Schwellen ändern; die aktuell geltenden Werte stehen auf der Gründungsseite."
          ],
          [
            "Wie funktioniert das mit dem Ruhm?",
            "Für jeweils 2 getätigte Freischaltungen aus dem Gildex-Katalog steigt das Gildenhaus automatisch eine Ruhm-Stufe auf.\nDie Ruhm-Stufe entscheidet über das visuelle Erscheinungsbild deines Gildenhauses! Auf der \"Gildenübersicht\"-Seite verändert sich dadurch das große Hintergrundbild der Gilde (die Burg/Halle wird prunkvoller).\nDein Ruhm und das Erscheinungsbild repräsentieren also direkt, wie viel Gildex die Gilde durch gute Taten bereits gemeinsam erarbeitet und investiert hat."
          ],
          [
            "Wie funktionieren Gruppenaktionen?",
            "Ein Gildenadmin kündigt eine freiwillige, nichtkommerzielle Aktion über eine eigene Formularseite an. Einladungen melden niemanden automatisch an. Alle melden sich selbst an, auch der Organisator, wenn er XP erhalten möchte. Ab Beginn bestätigt jede Person ihre tatsächliche Teilnahme selbst. Mindestens zwei Bestätigungen sind nötig. Der Organisator reicht den gemeinsamen Nachweis und die XP-Verteilung ein. Erst die endgültige Freigabe durch das Tribunal gibt die Belohnung frei. Bei Absage verschwinden die Einladungsbenachrichtigungen dieser Aktion; bereits Angemeldete erhalten eine Absagebenachrichtigung. Gildenadmins finden den ausführlichen Leitfaden über das Info-Icon bei den Gruppenaktionen."
          ],
          [
            "Warum haben Gruppenaktionen eigene XP-Bänder?",
            "Mehrere Abenteurer teilen sich einen gemeinsamen Pool. Die Gruppenbänder sind unabhängig von den Einzelbändern einstellbar. Alle Werte gelten vor Boni und Verteilung:\n\nBand · Einzelaktion / Gruppenpool\n1 · {{xpBand1}} / {{groupBand1}} XP\n2 · {{xpBand2}} / {{groupBand2}} XP\n3 · {{xpBand3}} / {{groupBand3}} XP\n4 · {{xpBand4}} / {{groupBand4}} XP\n5 · {{xpBand5}} / {{groupBand5}} XP\n6 · {{xpBand6}} / {{groupBand6}} XP\n7 · nur Gruppe: {{groupBand7}} XP\n8 · nur Gruppe: {{groupBand8}} XP\n\nDer Pool wächst nicht automatisch mit der Teilnehmerzahl. Bei gleichen Anteilen wird der eingestellte Gruppenpool gleichmäßig geteilt; mit mehr Personen fällt der Anteil kleiner aus.\n\nZeit und Einsatz sowie Planung und Abstimmung bestimmen das Band. Gruppen haben zusätzlich „Umfangreicher Gemeinschaftseinsatz“ und „Mehrstufige Organisation“. Beide höchsten Stufen ergeben Band 8. Das Tribunal beurteilt die belegten Beiträge und den tatsächlichen Organisationsaufwand."
          ],
          [
            "Wie verteilt der Organisator die Gruppen-XP?",
            "Genau 100 % werden in ganzen Prozent verteilt, ausschließlich auf bestätigte Teilnehmende. Pro Person sind 0–50 % erlaubt, auch für den Organisator. Mindestens zwei Personen brauchen einen positiven Anteil. Beispiel für fünf Personen: 40 / 25 / 15 / 10 / 10 %.\n\nDas Tribunal muss der Verteilung ausdrücklich zustimmen. Während der Prüfung sind die Anteile gesperrt. Nach einer Rückgabe kann der Organisator sie überarbeiten und erneut einreichen; eine neue Prüfrunde beginnt. 0 % gibt weder XP noch Karma und trägt keinen Gruppenbuff bei. Die 50-%-Grenze gilt vor persönlichen Boni."
          ],
          [
            "Was passiert, wenn jemand nicht erscheint?",
            "Wer sich abmeldet oder die Teilnahme nicht bestätigt, erhält keine Belohnung und liefert keinen Gruppenbuff. Nur angemeldete Personen werden bei Einreichung zurückgezogen. Warte deshalb auf die Bestätigung aller tatsächlich Beteiligten.\n\nFür falsche Teilnahmebestätigungen gibt es derzeit keinen eigenen Meldebutton oder eine automatische Strafe. Der Organisator kann vor der Einreichung 0 % vergeben und den Sachverhalt in der Beschreibung erläutern. Nach der Einreichung ist für Änderungen eine Rückgabe durch das Tribunal nötig."
          ],
          [
            "Wie wirken Buffs auf den Gruppenpool?",
            "Zuerst wird der Pool berechnet: Basis-XP × Eventfaktor × (1 + Gildenausbau + Gruppenbuff), anschließend abgerundet. Danach werden die gespeicherten Prozentanteile verteilt und persönliche Boni angewandt. Gesamt-XP und Kategorie-XP werden getrennt berechnet.\n\n• Nur bestätigte Personen mit positivem Anteil liefern Gruppenbuffs.\n• Der stärkste Bardenbonus zählt einmal, standardmäßig +10 %.\n• Gruppen-Mentor gibt +5 / +10 / +15 % je Rang; Beiträge mehrerer Personen werden addiert. Klassen-Gruppenbonus und Gruppen-Talente zusammen sind auf +50 % begrenzt.\n• Gildenausbau zählt mit der höchsten freigeschalteten Stufe (+1 bis +5 %). Der persönliche Gildenbonus von +5 % wirkt erst nach der Aufteilung.\n• Das Erfahrungselixier gilt nur für Einzelaktionen; zeitlich begrenzte persönliche Buffs wirken hier nicht.\n\nBeispiel: 2.000 Basis-XP, kein Eventbonus, +5 % Gildenausbau, +10 % Barde und +10 % Gruppen-Mentor ergeben 2.500 Pool-XP. Bei 40 / 25 / 15 / 10 / 10 % sind das 1.000 / 625 / 375 / 250 / 250 XP vor persönlichen Boni. Rest-XP bleiben bei der Aufteilung erhalten; persönliche XP werden anschließend abgerundet.\n\nKlassen- und Talenteffekte werden bei Einreichung gespeichert, bei überarbeiteter Neueinreichung erneut erfasst. Eventfaktor und Gildenausbau werden in der ersten Tribunalprüfung festgehalten."
          ],
          [
            "Dürfen Partner Aufgaben über Gilden vergeben?",
            "Nein. Gildenaktionen dürfen keine bezahlte Stelle, Arbeitsschicht oder reguläre kommerzielle Leistung ersetzen. Gildenadmins bestätigen vor jeder Ausrufung den gemeinnützigen und freiwilligen Charakter."
          ],
          [
            "Was sind Gildex?",
            "Gildex sind interne Gilden-Fortschrittspunkte ohne Geldwert:\n• Bei bestätigten guten Taten erhält die Gilde zusätzlich einen Anteil der Basis-XP als Gildex (deine XP bleiben unberührt).\n• Gildex sind weder kaufbar, auszahlbar noch übertragbar.\n• Gildenadmins können Gildex ausschließlich für interne Gildendekorationen und Komfortfunktionen ausgeben."
          ],
          [
            "Was ist der Unterschied zwischen Gildenruhm und Gildex?",
            "• Gildenruhm: Spiegelt den gesamten bisherigen Fortschritt der Gilde wider und bestimmt das Aussehen der Gildenhalle.\n• Gildex: Verfügbares Guthaben für interne Freischaltungen (Ausgaben verringern den Gildenruhm nicht)."
          ]
        ]
      ],
      [
        "Partner & QR-Pass",
        [
          [
            "Wie löse ich ein Angebot ein?",
            "Öffne deinen QR-Pass:\n• Ein Partner scannt den Code und sieht berechtigte Profildaten.\n• Signatur, Ablaufzeit, Benutzerzuordnung und Bedingungen werden serverseitig geprüft."
          ],
          [
            "Kann ein Screenshot mehrfach verwendet werden?",
            "Nein. Der Pass ist signiert, läuft schnell ab und enthält eine Einmal-ID, die nach Erstnutzung dauerhaft entwertet wird."
          ],
          [
            "Sind XP Geld oder ein Zahlungsmittel?",
            "Nein. XP sind Spielfortschritt ohne Geldwert. Partnerangebote werden durch Fortschritt freigeschaltet; Partner tragen die Verantwortung für Erfüllung und Verfügbarkeit."
          ],
          [
            "Verändern Klassen den Partnerrabatt?",
            "Nein. Es gilt stets der reguläre Rabatt des Partnerangebots."
          ]
        ]
      ],
      [
        "Klassen, Perks & Karma",
        [
          [
            "Kann ich meine Klasse nach der Registrierung ändern?",
            "Ja. In deinem Profil kannst du unter „Klasse ändern“ einmalig eine andere verfügbare Klasse auswählen und bestätigen. Das ist nur innerhalb der ersten sieben Tage (168 Stunden) nach deiner Registrierung möglich. Das genaue Ablaufdatum steht im Profil. Nach dem Wechsel oder nach Ablauf der Frist ist kein weiterer Klassenwechsel möglich."
          ],
          [
            "Was passiert beim Klassenwechsel mit meinen XP und Boni?",
            "Bereits gutgeschriebene Gesamt- und Kategorie-XP werden nicht neu berechnet. Auch deine Level und dein Rang bleiben unverändert. Laufende Heldentaten behalten ihre gespeicherten Boni; neue Heldentaten verwenden die Boni deiner neuen Klasse. Bereits verbrauchte Klassenfähigkeiten werden durch den Wechsel nicht zurückgesetzt."
          ],
          [
            "Welche Klassen-Perks gibt es?",
            "Alle Klassen erhalten +20 % Gesamt- und Kategorie-XP bei bestätigten guten Taten ihrer Kategorie. Die spezifischen Fähigkeiten sind:\n• Späher: 10 % kürzerer Cooldown\n• Verteidiger: +1 Slot für parallele Einreichungen\n• Paladin: +1 Karma bei jeder bestätigten guten Tat\n• Schmied: Eine abgelehnte einzelne gute Tat einmal reparieren\n• Barde: +10 % Gruppen-XP (nicht stapelbar)\n• Händler: Einmal wöchentlich Cooldown überspringen\n• Alchemist: Einmal wöchentlich +25 % XP auf eine Einzel-Einreichung\n• Magier: +10 % Kategorie-XP außerhalb der eigenen Kategorie\n• Druide: +20 % Gildex aus eigenen einzelnen guten Taten\n• Kleriker: +1 Erholungs-Karma bei negativem Karma (bis max. 0)"
          ],
          [
            "Sind die Talente je nach Klasse unterschiedlich?",
            "Nein. Alle Klassen haben dieselben Talentpfade und Talente. Deine Klasse bestimmt deine Klassenfähigkeit; Talente kannst du unabhängig davon freischalten."
          ],
          [
            "Was ist Karma?",
            "Karma ist dein persönlicher Vertrauenswert (Skala von {{karmaMinimum}} bis {{karmaMaximum}}):\n• Beginnt bei 0 und ist keine Währung.\n• Direkte Karma-Abzüge verändern XP nicht.\n• Höheres Karma schaltet Vertrauensstufen frei."
          ],
          [
            "Wie bekomme ich Karma?",
            "Bestätigte gute Taten belohnen mit Karma:\n• Mindestens +1 Karma pro bestätigter guter Tat (oder konfigurierte Belohnung)\n• Karma-Talente erhöhen den Ertrag zusätzlich\n• Bei negativem Karma greifen Erholungsboni bis max. 0\n• Ablehnungen oder Rückzüge ziehen kein Karma ab\n• Bei Gruppenaktionen erhalten nur bestätigte Personen mit positivem XP-Anteil Karma; 0 % gibt kein Karma."
          ],
          [
            "Wer darf Karma abziehen?",
            "Bei Fehlverhalten oder Betrug:\n• Gildenadmins dürfen Mitgliedern ihrer Gilde Karma abziehen (1–100 Punkte mit Begründung).\n• Superadmins können gildenübergreifend handeln.\n• Du erhältst eine Benachrichtigung mit Begründung und Urheber."
          ],
          [
            "Werde ich durch negatives Karma gesperrt?",
            "Von {{partner}} bis {{partnerEnd}} Karma sind Partnervorteile gesperrt. Von {{xp}} bis {{xpEnd}} werden zusätzlich täglich {{percent}} % der Gesamt-XP abgezogen. Ab {{tribunalLoss}} entfällt eine bestehende Tribunalrolle. Von {{suspension}} bis {{karmaMinimum}} wird das Konto {{months}} Kalendermonat(e) gesperrt. Bestätigte gute Taten bauen Karma wieder auf."
          ],
          [
            "Wo verwalte ich Karma als Admin?",
            "Admins finden im Profil die Funktion „Karma verwalten“ zur Personensuche und Vergabe von Karma-Abzügen mit Pflichtnachricht."
          ]
        ]
      ]
    ]
  },
  "admin_directory": {
    "delete_guild": "Gilde löschen",
    "delete_guild_confirm": "Gilde „{{name}}“ endgültig löschen? Alle Mitglieder verlassen die Gilde, ihre Benutzerkonten bleiben erhalten. Gildendaten und Freischaltungen werden gelöscht und laufende Gruppenaktionen abgebrochen. Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "guilds": "Alle Gilden",
    "karma": "Karma",
    "karma_suspended": "Durch Karma temporär gesperrt",
    "karma_suspended_until": "Karma-Sperre bis {{date}}",
    "manual_suspension_separate": "Die manuelle Kontosperre wird separat verwaltet und bleibt von der Karma-Sperre unabhängig.",
    "search_guilds": "Gildenname oder Beschreibung suchen …",
    "renown": "Ruhm",
    "treasury": "Schatzkammer",
    "total_xp": "Gesamt-XP",
    "manage_guild": "Gilde verwalten",
    "view_public": "Öffentliche Gildenseite",
    "stats_summary": "Gilden-Kennzahlen",
    "all_time_renown": "Gesamter Ruhm",
    "rate": "Gildex-Rate",
    "tab_karma": "Karma-Moderation",
    "level_and_rank": "Stufe & Rang",
    "hero_class": "Heldenklasse",
    "karma_score": "Karma-Score",
    "guild_hall": "Gildenhalle ({{name}})",
    "error_loading_guild_details": "Fehler beim Laden der Gildendetails",
    "rate_label": "Rate: {{rate}}% Basis-XP",
    "unlocked_upgrades": "Freigeschaltete Gilden-Upgrades",
    "actions_and_gildex": "Gute Taten & Gildex-Generierung",
    "gildex_generated": "+{{amount}} Gildex generiert",
    "total_gildex_yield": "+{{amount}} Gildex Gesamtertrag",
    "next_renown_stage": "Nächste Ruhmstufe: {{name}}",
    "renown_progress": "{{current}} / {{max}} Ruhm",
    "guild_members_count": "Gildenmitglieder ({{count}})",
    "guild_leader": "Gildenleiter",
    "xp_collected": "{{amount}} XP gesammelt",
    "no_members_in_guild": "Keine Mitglieder in dieser Gilde.",
    "guild_announcements_count": "Gilden-Aushänge & Ankündigungen ({{count}})",
    "class": "Klasse",
    "no_guild": "Keine Gilde"
  },
  "classesAndRanks": {
    "title": "Klassen",
    "subtitle": "Entdecke die zehn Heldenklassen und ihre Fähigkeiten.",
    "classes": "Heldenklassen",
    "classesIntro": "Wähle eine Klasse, die zu deinen Interessen passt. In ihrer Kategorie erhältst du mehr XP und zusätzlich eine besondere Fähigkeit.",
    "perk": "Klassen-Perk",
    "noPerk": "Der konkrete Klassen-Perk wird in deiner Klassenkonfiguration angezeigt.",
    "loadError": "Die Klassenkonfiguration konnte nicht geladen werden. Es werden Standardwerte angezeigt."
  },
  "ranksGuide": {
    "title": "Ränge",
    "subtitle": "Dein Rang wächst mit den XP aus bestätigten guten Taten.",
    "ranks": "Rangaufstieg",
    "ranksIntro": "Dein Rang richtet sich nach allen XP, die du durch bestätigte gute Taten gesammelt hast.",
    "xp": "XP gesamt",
    "noteTitle": "Level und Rang einfach erklärt",
    "note": "Dein Level und Rang wachsen mit deinen Gesamt-XP aus bestätigten guten Taten. In jeder Kategorie sammelst du zusätzlich eigene Kategorie-XP.",
    "whyRanksTitle": "Warum sind Ränge wichtig?",
    "whyRanksIntro": "Dein Rang zeigt deinen Fortschritt und spielt bei einigen Möglichkeiten in Goodvale eine Rolle:",
    "whyRanks": [
      {
        "title": "Eigene Gilde gründen",
        "text": "Dafür brauchst du einen bestimmten Rang und musst weitere Voraussetzungen erfüllen."
      },
      {
        "title": "Für das Tribunal bewerben",
        "text": "Ab dem erforderlichen Rang kannst du dich für die Prüfung guter Taten bewerben. Die Rolle erhältst du erst nach Freigabe."
      },
      {
        "title": "Partnerangebote nutzen",
        "text": "Einzelne Angebote können einen Mindestrang voraussetzen. Die Bedingungen stehen beim jeweiligen Angebot."
      }
    ]
  },
  "landing": {
    "eyebrow": "Bring die Welt aufs nächste Level.",
    "title": "Das Abenteuer beginnt im echten Leben.",
    "guildFeature": {
      "title": "Eine Gilde macht aus einzelnen Taten ein gemeinsames Abenteuer.",
      "intro": "In einer Gilde findest du Menschen, mit denen du Ideen teilst, Hilfe organisierst und Erfolge feierst. Du kannst einer bestehenden Gemeinschaft beitreten oder eine eigene gründen. Euer Gildenheim zeigt, was ihr zusammen erreicht habt.",
      "points": [
        {
          "title": "Zusammen handeln",
          "body": "Plant freiwillige Gruppenaktionen, meldet euch selbst an und bestätigt eure Teilnahme. Nach der Prüfung durch das Tribunal wird die Gruppen-Erfahrung unter den bestätigten Teilnehmenden aufgeteilt. Klassen- und Talentboni können die gemeinsame Wirkung verstärken."
        },
        {
          "title": "Die Schatzkammer füllen",
          "body": "Bestätigte gute Taten bringen der zugeordneten Gilde zusätzlich Gildex, ohne deine eigenen XP zu verringern. Damit schaltet die Gilde zum Beispiel Chat, Gruppenaktionen, Gestaltung für das Gildenheim und weitere Funktionen frei."
        },
        {
          "title": "Gemeinsam profitieren",
          "body": "Schon die Gildenmitgliedschaft gibt einen allgemeinen XP-Bonus von 5 %. Die Gilde kann mit Gildex zusätzliche XP-Booststufen freischalten. Es zählt die höchste gekaufte Stufe mit weiteren 1 bis 5 Prozentpunkten."
        }
      ],
      "closing": "Gildenruhm, gemeinsame Aktionen und freigeschaltete Räume machen sichtbar, wie eure Gemeinschaft wächst. Die Gildenleitung setzt die erspielten Gildex für gemeinsame Vorteile ein.",
      "action": "Abenteurer:in werden"
    },
    "partnerFeature": {
      "points": [
        {
          "title": "Sichtbar in der Region",
          "body": "Mit einem Partnerprofil stellst du dein Unternehmen, deinen Standort und deine Angebote vor. Abenteurer entdecken passende Vorteile, während sie durch echte gute Taten Fortschritte machen."
        },
        {
          "title": "Angebote passend gestalten",
          "body": "Erstelle Rabatte, Zugaben, Gutscheine oder Dienstleistungen. Du kannst Voraussetzungen wie Rang, XP, Kategorie, Karma und bestätigte Event-Taten sowie Zeitraum und Kontingent festlegen."
        },
        {
          "title": "Einfach einlösen",
          "body": "Vor Ort prüfst du einen zeitlich begrenzten QR-Pass. Digitale Angebote lösen berechtigte Abenteurer selbst ein. Im Partnerbereich verwaltest du Angebote und siehst die Einlösungen."
        }
      ],
      "closing": "Partnerangebote belohnen Engagement; sie kaufen keine XP oder Ränge. Nach der Registrierung wird dein Partnerkonto freigegeben, bevor du Angebote veröffentlichst."
    },
    "roles_kicker": "Das Goodvale-Ökosystem",
    "roles_title": "4 Instanzen. Ein gemeinsames Ziel.",
    "karma_title": "Karma auf einen Blick",
    "karma_intro": "Der Karma-Balken zeigt, wann Vorteile gesperrt werden, Tribunalrechte entfallen und weitere Folgen greifen. Wähle eine Schwelle für Details.",
    "karma_more": "Karma im Detail",
    "subtitle": "Ob du jemandem im Alltag hilfst oder dich für deine Umgebung einsetzt: Jede gute Tat zählt. Von kleinen Gesten bis zu Heldentaten mit deiner Gilde kannst du viel erreichen. Sammle Erfahrung und entdecke Belohnungen lokaler Partner.",
    "join": "Gilde beitreten",
    "classesSubtitle": "Zehn Klassen, ein gemeinsames Ziel: mit großen und kleinen Taten die Welt ein Stück besser machen.",
    "cards": [
      [
        "Abenteurer",
        "Tu Gutes im Alltag – auch kleine Gesten können Großes bewirken. Sammle Erfahrungspunkte, steige im Rang auf und schalte Vorteile frei."
      ],
      [
        "Tribunal",
        "Als erfahrener Hüter prüfst und bestätigst du eingereichte gute Taten nach strengen Qualitäts- und Ehrenkodex-Kriterien."
      ],
      [
        "Gilden",
        "Schließe dich mit Gleichgesinnten zusammen, meistere gemeinsame Herausforderungen und baut eure Gildenkasse auf."
      ],
      [
        "Partner",
        "Unterstütze engagierte Menschen in deiner Region und belohne verifizierte gute Taten mit echten Vorteilen."
      ]
    ],
    "hero_prefix": "Kleine Taten. Große",
    "hero_emphasis": "Wirkung.",
    "categories_examples": "Beispiele für gute Taten und XP"
  },
  "partnerSettings": {
    "subtitle": "Verwalte dein Partnerprofil und deine exklusiven Angebote für Abenteurer."
  },
  "guild_treasury": {
    "confirm": "Möchtest du \"{{name}}\" für {{price}} Gildex freischalten?",
    "insufficient": "Nicht genügend Gildex.",
    "loading": "Lade Schatzkammer...",
    "shop_title": "Gilden-Shop & Katalog",
    "shop_intro": "Schalte exklusive Hallen-Themes, Stammtisch und Ausbauten für deine Gilde frei.",
    "title": "Gildex-Ledger & Historie",
    "rate": "Aktuelle Umwandlungsrate: {{rate}}% der Basis-XP",
    "no_money": "Gildex können nicht gekauft werden.",
    "admin": "Nur Gilden-Admins können Gildex ausgeben.",
    "base": "Basis: {{xp}} XP ({{rate}}%)"
  },
  "guildGildexTreasury": {
    "title": "Gildex-Schatzkammer",
    "subtitle": "Die gemeinsamen Reserven der Gilde. Gildex fließt anteilig durch bestätigte gute Taten in die Kasse."
  },
  "adminHeroicActions": {
    "reviewUnavailable": {
      "assignment": "Aktuell keine zulässige Prüfzuweisung für dich. Zuweisung, Gildenbezug und Prüfpausen werden berücksichtigt."
    },
    "tableHero": "Held",
    "keepWarning": "Vergebene XP, Karma und Gildenbelohnungen bleiben erhalten.",
    "reverseWarning": "Gebuchte XP, Kategorie-XP, Karma und Gildenbelohnungen werden zurückgerechnet, auch für Gruppenteilnehmer. Bereits ausgegebene Gildex können zu einem negativen Gildenkonto führen.",
    "reviewCategoryHint": "Prüfe die gewählte Kategorie und korrigiere sie bei Bedarf. Die erste Prüfung legt sie für diese Prüfrunde fest; Kategorie-XP und Boni richten sich danach.",
    "badge": "Tribunal & Moderation",
    "title": "Tribunal",
    "subtitle": "Prüfe offene gute Taten und bewerte Einsatz und Nachweise der Abenteurer.",
    "antiCheatNotice": "Hinweis: Aus Anti-Cheat-Gründen (Abklingzeiten, Gildenfilter und Durchmischung) erscheinen manche Einreichungen erst nach der Prüfung anderer guter Taten oder nach Ablauf einer Sperrfrist in der Übersicht.",
    "xpLabel": "XP und Basiswerte",
    "searchPlaceholder": "Gute Tat oder Abenteurer suchen…",
    "allRanks": "Alle Ränge",
    "allBands": "Alle XP-Bänder",
    "rank": "Rang",
    "xpBand": "XP-Band",
    "applications": "Bewerbungen für das Tribunal",
    "organizerOkay": "Gilden-Organisator-Richtlinie bestätigt",
    "organizerMissing": "Gilden-Organisator-Richtlinie noch nicht bestätigt",
    "heroEstimate": "Einschätzung des Helden:",
    "assessHint": "Passe Zeit und Einsatz, Planung und Abstimmung sowie XP-Werte verbindlich an.",
    "baseGroup": "Basis-XP (gesamte Gruppe)",
    "base": "Basis-XP",
    "categoryGroup": "Kategorie-XP (gesamte Gruppe)",
    "guidanceAdmin": "Admin-Prüfung erforderlich (außergewöhnlich oder hohe XP)."
  },
  "adminAppeals": {
    "detailIntro": "Prüfe die Begründung und entscheide über eine neue Tribunalrunde."
  },
  "quick_heroic_action": {
    "experience_elixir": "Erfahrungselixier: +25 % XP bei Bestätigung."
  },
  "heroicActions": {
    "slots_full_redirect": "Alle Slots sind durch offene Quests oder eine laufende Wartezeit belegt. Unter „Meine Slots“ siehst du, wann wieder ein Slot frei wird.",
    "breakdown": {
      "total": "Gesamt-XP",
      "category": "Kategorie-XP",
      "guild": "Gildenbonus",
      "classBonus": "Klassenbonus",
      "groupFormula": "Rechnung: ⌊{{base}} × {{event}} × (1 + {{guild}} % Gilde + {{party}} % Gruppe)⌋",
      "groupTotal": "Gruppen-XP nach Event-, Gilden- und Gruppenbonus: {{total}}",
      "share": "Anteil vor persönlichen Boni: {{xp}} XP ({{percent}} % gemäß Freigabe des Tribunals)",
      "legacyShare": "Anteil vor persönlichen Boni: {{xp}} XP bei {{count}} Teilnehmenden",
      "credited": "Persönlich gutgeschrieben: {{xp}} XP",
      "missingFactors": "Nicht einzeln rekonstruierbare Event-/Gildenwirkung und Rundung: {{xp}} XP",
      "rounding": "Der Event-Faktor wirkt zuerst. Gruppen-XP werden nach den Anteilen mit Restverteilung aufgeteilt; persönliche Boni werden danach angewendet und abgerundet.",
      "legacyFactors": "Bei dieser älteren Einreichung wurden nicht alle Faktoren gespeichert. Die endgültige Gutschrift stammt aus dem XP-Konto."
    },
    "categoryXp": "Kategorie-XP",
    "eine_reparatur_pro_h": "Eine Reparatur pro gute Tat. Überarbeite die Beschreibung oder reiche einen neuen Nachweis ein. Das Tribunal prüft erneut.",
    "klassenf_higkeit": "Klassenfähigkeit",
    "filterXp": "XP-Band",
    "allXpBands": "Alle XP-Stufen",
    "sortXpDesc": "XP (Höchste zuerst)",
    "sortXpAsc": "XP (Niedrigste zuerst)",
    "xpFor": "XP für",
    "closeXpBreakdown": "XP-Berechnung schließen",
    "showXpBreakdown": "XP-Berechnung anzeigen",
    "xpBreakdown": "XP-Berechnung",
    "baseXp": "Vom Tribunal festgelegte Basis-XP",
    "awardedXp": "Gutgeschriebene XP"
  },
  "heroicActionXpGuide": {
    "baseXp": "Basis-XP",
    "title": "XP-Hilfe und Beispiele",
    "intro": "Jede gute Tat zählt, auch kleine Alltagshilfen. Schätze ein, wie viel Zeit und Einsatz deine Tat erfordert hat und wie viel Planung und Abstimmung nötig waren. Beide Einschätzungen ergeben ein verbindliches XP-Band. Das Tribunal prüft deine Angaben und vergibt Basis-XP innerhalb dieses Bands. Klassen- oder Boost-Boni werden danach berechnet.",
    "subtitle": "Orientierung für Zeit und Einsatz, Planung und Abstimmung sowie XP-Bänder",
    "estimatedXp": "Ungefähre XP",
    "bandOption": "Band {{band}} ({{min}}–{{max}} XP)",
    "groupBaseXp": "Basis-XP im Gruppenpool",
    "groupIntro": "Gruppenaktionen haben acht eigene XP-Bänder mit höheren gemeinsamen Pools. Das Tribunal bewertet den belegten gemeinsamen Einsatz. Die Teilnehmerzahl allein erhöht den Pool nicht. Boni werden auf den Pool angewendet, danach wird er nach den gespeicherten Prozentanteilen verteilt. Einzelaktionen verwenden ihre eigenen sechs Bänder.",
    "mixedBandOption": "Band {{band}} · Einzel {{soloMin}}–{{soloMax}} / Gruppe {{min}}–{{max}} XP",
    "groupBandOption": "Gruppenband {{band}} ({{min}}–{{max}} XP)"
  },
  "guild_administration": {
    "profile_title": "Gilden-Stammdaten & Standort",
    "profile_intro": "Passe die offiziellen Stammdaten, das Leitbild und den geografischen Standort eures Gildenhauses auf der Weltkarte an.",
    "official_name": "Offizieller Gildenname",
    "description_label": "Gilden-Motto & Philosophie / Beschreibung",
    "description_placeholder": "Beschreibe die Ideale, Gute-Taten-Schwerpunkte und die Geschichte deiner Gilde...",
    "location_label": "Gilden-Standort auf der Weltkarte",
    "name_required": "Bitte gib einen offiziellen Gildennamen an.",
    "profile_saved": "Gilden-Stammdaten & Standort erfolgreich gespeichert!",
    "emblem_title": "Gilden-Wappenschmiede",
    "emblem_settings_title": "Gildenwappen verwalten",
    "emblem_intro": "Passe das heraldische Wappen deiner Gilde an. Das Banner repräsentiert euch im gesamten Königreich und auf Visitenkarten.",
    "emblem_alt": "Wappen",
    "customize_emblem": "Wappen anpassen",
    "save_emblem": "Wappen speichern",
    "emblem_admin_only": "Nur Gildenadmins können das Wappen bearbeiten und speichern.",
    "emblem_saved": "Gildenwappen erfolgreich geschmiedet.",
    "forge_upgrade_intro": "Die erweiterte Wappenschmiede mit zusätzlichen Motiven und Gestaltungsoptionen könnt ihr im Gilden-Shop freischalten.",
    "theme_title": "Gildenhallen-Design & Raumstil",
    "theme_intro": "Entdecke die Raumstile eurer Gildenhalle. Gildenadmins können freigeschaltete Designs für ihre Ansicht auswählen.",
    "theme_eyebrow": "Gildenhalle · Raumstile",
    "theme_default_description": "Die vertraute Halle eurer Gilde mit klassischem Burgcharakter.",
    "theme_forest": "Waldhalle",
    "theme_celestial": "Sternenhalle",
    "unlock_in_shop": "→ Im Shop freischalten ({{price}} Gildex)",
    "theme_saved": "Deine Gildenhallen-Ansicht wurde aktualisiert.",
    "applications_intro": "Überprüfe Beitrittsanfragen von Abenteurern, die eurem Bündnis beitreten möchten.",
    "bans_title": "Gilden-Sperren & Verbannte Abenteurer ({{count}})",
    "bans_intro": "Gebannte Spieler können dieser Gilde nicht mehr beitreten. Du kannst Sperren hier jederzeit wieder aufheben.",
    "no_bans": "Keine aktiven Gilden-Sperren vorhanden.",
    "ban_success": "\"{{name}}\" wurde erfolgreich aus der Gilde verbannt und gesperrt."
  },
  "guildDetail": {
    "active_adventurers": "{{count}} aktive Abenteurer",
    "einige_wappen_erford": "Einige Wappen erfordern die",
    "berpr_fe_neue_beitr": "Überprüfe neue Beitrittsanfragen von Abenteurern.",
    "passe_das_wappen_dei": "Passe das Wappen deiner Gilde an. Das Wappen repräsentiert euch im gesamten Königreich.",
    "gebannte_spieler_k_n": "Gebannte Spieler können dieser Gilde nicht mehr beitreten. Du kannst Sperren hier jederzeit aufheben.",
    "abenteurer_aus_gilde": "Abenteurer:in aus der Gilde bannen",
    "gildenhaus_nicht_gef": "Gildenhaus nicht gefunden",
    "der_abenteurer_wird": "Abenteurer:in wird sofort aus der Gilde entfernt und zukünftige Beitrittsanfragen werden dauerhaft blockiert.",
    "aktuelles_wappen": "Aktuelles Wappen",
    "zur_ck_zur_gilden_be": "Zurück zur Gildenübersicht",
    "erweiterte_wappensch": "Erweiterte Wappenschmiede",
    "wird_auf_visitenkart": "Wird auf Visitenkarten und in der Taverne angezeigt."
  },
  "adminClassCategoryManager": {
    "keine_klassen_vorhan": "Keine Klassen vorhanden.",
    "erkl_re_genau_wie_di_placeholder": "Erkläre genau, wie dieser Perk wirkt und auf welche guten Taten, XP oder Partnervorteile er sich auswirkt..."
  },
  "gameMechanics": {
    "faire_xp_teilung": "Faire XP-Teilung"
  },
  "guildMembersAdmin": {
    "der_abenteurer_wird": "Abenteurer:in wird sofort aus der Gilde entfernt und zukünftige Beitrittsanfragen werden dauerhaft blockiert.",
    "es_sind_derzeit_kein": "Es sind derzeit keine Abenteurer für diese Gilde blockiert.",
    "gesperrte_abenteurer": "Gesperrte Abenteurer",
    "abenteurer_aus_gilde": "Abenteurer:in aus der Gilde bannen",
    "lade_gesperrte_abent": "Lade gesperrte Abenteurer...",
    "neue_beitrittsanfrag": "Neue Beitrittsanfragen von Abenteurern erscheinen hier zur Überprüfung."
  },
  "systemEvents": {
    "karma": "Karma",
    "xp_multiplier": "+{{percent}} % XP (×{{multiplier}})",
    "base_xp": "★ {{count}} XP",
    "cat_xp": "🎖️ {{count}} Kat-XP",
    "karma_reward": "👑 {{count}} Karma",
    "base_xp_label": "Basis-XP",
    "cat_xp_label": "Kategorie-XP",
    "bonus_xp": "+{{percent}} % Event-XP."
  },
  "worldMapView": {
    "gilde_betreten": "Gilde betreten",
    "gildenruhm": "Gildenruhm",
    "w_hle_eine_gilde_ode": "Wähle eine Gilde oder einen Partner auf der Karte, um weitere Details zu erfahren.",
    "guilds": "Gilden",
    "guild_type": "Gilde"
  },
  "partnerDetail": {
    "adventurer_missing": "Abenteurer nicht gefunden.",
    "adventurer_required": "Nur freigeschaltete Abenteurer dürfen Angebote digital einlösen.",
    "how_to_redeem_desc": "Zeige an der Kasse oder beim Service deinen offiziellen Gilden-QR-Pass vor. Eine Partner:in scannt deinen Code und gewährt dir sofort den Vorteil!"
  },
  "heroicOverview": {
    "karma": "Karma",
    "total_xp": "Gesamt-XP"
  },
  "guild_overview": {
    "renown_and_stage": "Gildenruhm & Ausbaustufe",
    "renown_description": "Dauerhaft gesammelte Basis-XP aus den gutgeschriebenen guten Taten eurer Gilde.",
    "next_stage_from": "{{detail}} ab {{min}} Ruhm",
    "gildex_earned": "Gildex verdient",
    "balance_suffix": "Gildex-Guthaben: {{balance}}.",
    "guild_members": "Gildenmitglieder",
    "ep_boost_title": "Magischer XP-Boost",
    "ep_boost_active": "+{{percent}}% XP-Bonus aktiv",
    "ep_boost_inactive": "Kein XP-Bonus aktiv",
    "ep_boost_status_active": "XP-Bonus aktiv",
    "ep_boost_hint": "Schaltet Stufe 1 frei und sammelt als Gilde bei guten Taten mehr XP.",
    "ep_boost_desc": "Der magische Brunnen verstärkt die Erfahrungspunkte aller Gildenmitglieder bei allen abgeschlossenen guten Taten um {{percent}}%.",
    "ep_boost_upgrade": "Im Gilden-Shop aufwerten →",
    "ep_boost_activate": "Jetzt im Gilden-Shop freischalten →",
    "ep_boost_max": "Maximale XP-Boost-Stufe erreicht (+5%)"
  },
  "guild_hall_stage": {
    "aria_label": "Gildenhalle",
    "bg_alt": "Gildenhalle Hintergrund",
    "renown_suffix": "({{renown}} Ruhm)",
    "forest_theme_tooltip": "Waldhalle",
    "celestial_theme_tooltip": "Sternenhalle",
    "banner_aria": "Gildenwappen & Banner",
    "banner_sprite_alt": "Gildenbanner",
    "banner_crest_alt": "Wappen",
    "default_guild_name": "Gildenwappen",
    "profile_wall_aria": "Profilwand: Gildenmitglieder",
    "trophy_shelf_locked": "Trophäenraum (Gilden-Shop)",
    "fame_monument_aria": "Ruhmesmonument & Gute Taten",
    "fame_monument_sprite_alt": "Ruhmesmonument",
    "fame_monument_title": "Ruhmesmonument",
    "chest_aria": "Gildenkasse (Schatzkammer)",
    "chest_title": "Schatzkammer (Gildex & Tresor)",
    "shop_stall_aria": "Gilden-Kaufmannsstand",
    "shop_stall_title": "Gilden-Katalog & Freischaltungen",
    "stammtisch_aria": "Gilden-Stammtisch (Chat)",
    "stammtisch_unlocked": "Gilden-Stammtisch",
    "stammtisch_locked": "Gilden-Stammtisch (Gilden-Shop)",
    "group_table_unlocked": "Gilden-Konferenztisch (Gruppen-Aktionen)",
    "group_table_locked": "Gruppenaktionstisch (Gilden-Shop)",
    "admin_desk_aria": "Gildenleiter-Schreibtisch (Verwaltung)",
    "admin_desk_unlocked": "Verwaltungspult (Gildenleitung)",
    "admin_desk_locked": "Gildenleiter-Pult (Gilden-Shop)",
    "anvil_aria": "Wappen-Amboss (Gildendesign)",
    "anvil_sprite_alt": "Wappen-Amboss",
    "anvil_unlocked": "Wappen-Amboss (Emblem-Builder)",
    "anvil_locked": "Wappen-Amboss (Gilden-Shop)",
    "fountain_aria": "XP-Brunnen",
    "fountain_sprite_alt": "XP-Brunnen",
    "fountain_unlocked": "XP-Brunnen (+{{percent}}% XP-Boost)",
    "fountain_locked": "XP-Brunnen (Gilden-Shop)"
  },
  "system_admin": {
    "adventurer_view": "Abenteurer-Ansicht"
  },
  "partner_portal": {
    "brand_title": "Portal"
  },
  "partner_redemptions": {
    "subtitle": "Übersicht aller durchgeführten Einlösungen deiner Angebote durch Abenteurer (Vor Ort und Remote/Digital).",
    "stat_adventurers": "Erreichte Abenteurer",
    "search_placeholder": "Abenteurer, Angebot, Gilde oder Code suchen …",
    "no_redemptions_desc": "Sobald Abenteurer deine Angebote vor Ort über den QR-Pass oder digital einlösen, erscheinen sie in dieser Liste."
  },
  "partner_profile": {
    "bio_placeholder": "Beschreibe dein Unternehmen, dein Angebot oder Besonderheiten für Abenteurer auf der Weltkarte …"
  },
  "audit_ui": {
    "room": {
      "news": {
        "description": "Neuigkeiten aus deiner Gilde"
      },
      "roster": {
        "description": "Die Menschen hinter deiner Gilde"
      },
      "trophies": {
        "title": "Trophäenraum"
      },
      "design": {
        "title": "Gildenhallen-Design"
      },
      "settings": {
        "description": "Mitglieder und Gildeneinstellungen verwalten"
      },
      "treasury": {
        "title": "Schatzkammer",
        "description": "Euer gemeinsamer Gildenschatz"
      },
      "forge": {
        "title": "Wappenschmiede",
        "description": "Euer Gildenwappen und seine Gestaltung"
      },
      "stats": {
        "title": "Ruhm & Statistik",
        "description": "Euren Gildenruhm und Fortschritt entdecken"
      }
    },
    "all_guilds": "Alle Gilden",
    "view_hall_image": "Ganzes Bild der Gildenhalle anzeigen",
    "emblem": "Gildenwappen",
    "welcome": "Willkommen in eurem Gildenheim",
    "your_guild": "Deine Gilde",
    "home": "Gildenheim",
    "updates": "Aktuelles aus der Gilde",
    "news_hint": "Hier erscheinen die Neuigkeiten eurer Gilde.",
    "treasure": "Gemeinsamer Gildenschatz",
    "rooms": "Eure Gildenräume",
    "unlock_shop": "Im Gilden-Shop freischalten",
    "shop": "Der Gildenladen",
    "shop_heading": "Ein Zuhause, das mit euch wächst.",
    "tools": "Gildenwerkzeuge",
    "stats": "Ruhm & Statistiken",
    "boost_discover": "XP-Bonus entdecken",
    "forge": "Wappenschmiede",
    "boost": "XP-Bonus +{{percent}} %",
    "theme_alt": "{{theme}} mit den angrenzenden Gildenräumen",
    "themes": {
      "default": "Standard-Feste",
      "forest": "Waldhalle",
      "celestial": "Sternenhalle"
    },
    "karma_designation": "Karma-Bezeichnung",
    "guild": "Gilde",
    "no_guild": "Noch keine Gilde",
    "renown": [
      "Gründung",
      "Anerkannt",
      "Angesehen",
      "Berühmt",
      "Legendär"
    ]
  },
  "categories_guide": {
    "intro": "Jede gute Tat gehört zu einem Bereich. Dort sammelst du zusätzlich zu deinen Gesamt-XP eigene Kategorie-XP. Wähle die Kategorie, die am besten zu deinem tatsächlichen Beitrag passt.",
    "examples_link": "Beispiele und XP ansehen"
  },
  "category_showcase": {
    "xp_caption": "Gute Taten. Eigene Kategorie-XP."
  },
  "landing_classes": {
    "heading_title": "Wähle deinen Weg",
    "heading_subtitle": "Zehn Klassen, ein gemeinsames Ziel: echte gute Taten sichtbar machen.",
    "picker_label": "Klasse für die Vorschau wählen",
    "loading_perks": "Klassen-Perks werden geladen …",
    "no_perks": "Für diese Klasse sind aktuell keine Perks hinterlegt.",
    "selected_class": "Ausgewählte Klasse",
    "explore_class": "Klasse entdecken",
    "no_classes": "Aktuell sind keine Klassen verfügbar.",
    "choose_class_title": "Wähle deine Klasse",
    "choose_class_hint": "Klicke auf ein Emblem oder den Button, um deine Klasse festzulegen."
  },
  "good_deed_examples": {
    "intro": "Diese Beispiele zeigen, welcher Aufwand ungefähr in welche XP-Spanne fällt. Das Tribunal bewertet deine tatsächliche Tat und den Nachweis; die Zahlen sind Richtwerte.",
    "table_label": "XP-Beispiele",
    "xp_title": "Wie werden XP bestimmt?",
    "xp_intro": "Entscheidend sind Zeit, Belastung und Verantwortung sowie Planung, Abstimmung und Beteiligte. Bei Spenden zählt dein eigener Einsatz, nicht der Geld- oder Warenwert. XP gibt es erst nach der endgültigen Bestätigung."
  },
  "guildHeroicActions": {
    "statuses": {
      "PendingReview": "Beim Tribunal"
    },
    "chat": {
      "submitted": "[GUTE TAT] {{title}} wurde mit {{count}} bestätigten Teilnehmenden beim Tribunal eingereicht.",
      "evidenceUploaded": "[GUTE TAT] {{title}}: Der verschlüsselte Nachweis wurde hochgeladen und die gute Tat an das Tribunal übergeben."
    },
    "adminOnly": "Nur Gilden-Admins können Gruppenaktionen ausrufen.",
    "intro": "Gildenmitglieder organisieren sich gemeinsam. Der Organisator verteilt die bestätigten XP; das Tribunal prüft die Verteilung.",
    "locked": "Gruppenaktionen sind noch nicht freigeschaltet. Ein Gilden-Admin kann sie im Gildex-Shop freischalten.",
    "split": "Basis-XP, danach gemäß Verteilung des Organisators",
    "allocationTitle": "XP-Verteilung",
    "submit": "Beim Tribunal einreichen",
    "resubmit": "Erneut beim Tribunal einreichen",
    "allocationFor": "XP-Anteil für {{name}}",
    "allocationBonuses": "Diese Anteile gelten vor persönlichen Boni. Ganze XP werden mit Restverteilung gerundet; dadurch ist eine Abweichung von weniger als 1 XP möglich.",
    "allocationReviewTitle": "XP-Verteilung des Organisators",
    "allocationApprove": "Hast du die XP-Verteilung des Organisators geprüft und gibst sie frei?",
    "guideLink": "Ablauf und XP einer Gruppenaktion erklären"
  },
  "groupActionGuide": {
    "eyebrow": "Leitfaden für Gildenadmins",
    "intro": "Anna organisiert eine Müllsammelaktion mit Ben, Clara, David und Eva. Hier siehst du den Weg von der Einladung bis zur Auszahlung – einschließlich Abmeldungen, Tribunal und XP-Boni.",
    "navigation": [
      "Ablauf",
      "Nichterscheinen",
      "XP & Buffs",
      "Entscheidungen & Abschluss"
    ],
    "steps": [
      {
        "title": "Aktion ankündigen",
        "text": "Die Gilde benötigt die Freischaltung Gruppenaktionen. Über „Gute Tat ausrufen“ öffnest du eine eigene Formularseite. Dort legst du Titel, Beschreibung, Kategorie, Schwierigkeit, Komplexität und Termin fest; Anmeldeschluss und Teilnehmerlimit sind optional. Bestätige Freiwilligkeit, nicht kommerziellen Zweck, sichere Organisation und dass keine bezahlte Arbeit ersetzt wird. Die Mitglieder werden benachrichtigt."
      },
      {
        "title": "Einladen und selbst anmelden",
        "text": "Einladungen melden niemanden automatisch an. Alle fünf melden sich selbst an, auch Anna, wenn sie XP erhalten möchte. Die Anmeldung benötigt und belegt einen freien Gute-Tat-Slot. Solange die Aktion nicht eingereicht ist, können Personen sich abmelden und der Gildenadmin kann die Aktion absagen. Bei Absage werden die Einladungsbenachrichtigungen dieser Aktion entfernt; angemeldete Mitglieder erhalten eine Absagebenachrichtigung."
      },
      {
        "title": "Teilnehmen und selbst bestätigen",
        "text": "Ab dem geplanten Termin bestätigt jede Person ihre tatsächliche Teilnahme selbst. Es gibt keine stellvertretende oder gegenseitige Bestätigung. Warte vor dem Einreichen auf alle tatsächlichen Teilnehmer: Mindestens zwei Bestätigungen sind notwendig; nur angemeldete Personen werden beim Einreichen als zurückgezogen behandelt."
      },
      {
        "title": "100 % in ganzen Prozent verteilen",
        "text": "Anna verteilt beispielsweise 40 / 25 / 15 / 10 / 10 %. Jede Person darf höchstens 50 % erhalten, Anna eingeschlossen. Nur bestätigte Personen zählen. 0 % ist erlaubt, mindestens zwei Personen benötigen einen positiven Anteil. Nachkommastellen sind nicht erlaubt. Bei mehr als 100 Personen müssen einige 0 % erhalten. Eine zusätzliche Zustimmung der Teilnehmer zur Verteilung ist nicht vorgesehen."
      },
      {
        "title": "Gemeinsamen Nachweis hochladen",
        "text": "Wähle ein Bild, ein PDF oder ein MP4 und bestätige die Datenschutzhinweise. Zuerst wird die Einreichung gespeichert, dann der Nachweis hochgeladen. Bei einem Uploadfehler kannst du den Upload nachholen. Erst danach geht die Aktion an das Tribunal. Die Anteile sind während der Prüfung gesperrt."
      },
      {
        "title": "Tribunal entscheidet",
        "text": "Das Tribunal prüft Nachweis und Verteilung. Die erste Prüfung legt Kategorie, Schwierigkeit, Komplexität sowie Basis- und Kategorie-XP fest. Jede Zustimmung zur Aktion muss die Verteilung ausdrücklich bestätigen. Eigene Aktionen und für reguläre Moderatoren Aktionen der eigenen Gilde sind ausgeschlossen. Bei Freigabe werden die Belohnungen verbucht."
      }
    ],
    "absence": [
      {
        "title": "Eva meldet sich ab oder bestätigt nicht",
        "text": "Eva erhält keine XP und liefert keinen Gruppenbuff. Bleibt sie nur angemeldet, wird sie bei der Einreichung automatisch zurückgezogen. Anna verteilt 100 % auf die übrigen bestätigten Personen. Auch wer tatsächlich dabei war, aber die Bestätigung vergessen hat, wird so ausgeschlossen."
      },
      {
        "title": "Eva bestätigt fälschlich ihre Teilnahme",
        "text": "Einen eigenen Button zum Melden von Nichterscheinen, einen Anwesenheitsnachweis oder eine automatische Strafe gibt es derzeit nicht. Anna kann vor der Einreichung 0 % zuweisen und den Sachverhalt in der Beschreibung erläutern. Eva bleibt technisch bestätigt, erhält aber weder XP noch Karma und trägt keinen Gruppenbuff bei. Nach Einreichung ist für eine Änderung eine Rückgabe durch das Tribunal nötig."
      },
      {
        "title": "Was die Prozentregel nicht prüft",
        "text": "Ein positiver Anteil ab 1 % aktiviert den vollständigen passenden Gruppenbuff der Person. Das System prüft keine Mindestleistung. Die tatsächlichen Beiträge müssen über Beschreibung, Nachweis und Tribunal nachvollziehbar sein."
      }
    ],
    "xpTitle": "So wirken XP und Buffs",
    "xpIntro": "Zuerst wird ein gemeinsamer XP-Pool berechnet, dann nach den gespeicherten Anteilen verteilt. Persönliche Boni wirken anschließend auf den eigenen Anteil. Gesamt-XP und Kategorie-XP werden getrennt berechnet.",
    "formula": "Gruppenpool = abrunden(Basis-XP × Eventfaktor × (1 + Gildenausbau + Gruppenbuff))",
    "example": "Beispiel in Gruppenband 5: Das Tribunal setzt 2.000 Basis-XP und 2.000 Kategorie-XP an. Kein Eventbonus (Faktor 1), +5 % Gildenausbau, +10 % durch Ben als Barden und +10 % durch Claras Gruppen-Mentor Rang 2 ergeben je 2.500 XP im Pool. Alle fünf haben zusätzlich den persönlichen Gildenbonus von 5 %. Anna ist Druide und bekommt in Umwelt & Natur weitere 20 %. David ist Magier und bekommt hier weitere 10 % Kategorie-XP. Weitere Talente nehmen wir nicht an.",
    "columns": [
      "Person",
      "Anteil",
      "Pool-Anteil",
      "Gesamt-XP",
      "Kategorie-XP"
    ],
    "rows": [
      [
        "Anna · Druide",
        "40 %",
        "1000",
        "1250",
        "1250"
      ],
      [
        "Ben · Barde",
        "25 %",
        "625",
        "656",
        "656"
      ],
      [
        "Clara",
        "15 %",
        "375",
        "393",
        "393"
      ],
      [
        "David · Magier",
        "10 %",
        "250",
        "262",
        "287"
      ],
      [
        "Eva",
        "10 %",
        "250",
        "262",
        "262"
      ],
      [
        "Summe",
        "100 %",
        "2500",
        "2823",
        "2848"
      ]
    ],
    "rounding": "Die Pool-Aufteilung verteilt Rest-XP deterministisch, damit keine Pool-XP verloren gehen. Ein Anteil kann durch Ganzzahlrundung um weniger als 1 XP vom Prozentwert abweichen. Persönliche XP werden danach abgerundet.",
    "buffs": [
      "XP-Events multiplizieren die Basis-XP. Ohne aktives Event ist der Faktor 1.",
      "Gildenausbau: Nur die höchste freigeschaltete Stufe zählt (+1 bis +5 %). Zusätzlich gibt die Gildenmitgliedschaft persönlich +5 %.",
      "Barde: standardmäßig +10 % für die Gruppe. Mehrere Barden stapeln diesen Klassenbonus nicht; der stärkste Klassen-Gruppenbonus zählt einmal.",
      "Gruppen-Mentor: +5 / +10 / +15 % je Rang. Beiträge mehrerer Personen werden addiert. Klassen-Gruppenbonus und Gruppen-Talente zusammen sind auf +50 % begrenzt.",
      "Nur bestätigte Personen mit positivem XP-Anteil liefern Gruppenbuffs. Ein Buff wird nicht mit dem Prozentanteil seines Besitzers verkleinert.",
      "Passende Klassenboni geben standardmäßig +20 % Gesamt- und Kategorie-XP. Persönliche XP-Boni werden addiert; reine Kategorie-Boni erhöhen nur Kategorie-XP.",
      "Das wöchentliche Erfahrungselixier gilt nur für Einzelaktionen. Zeitlich begrenzte persönliche Buffs werden für diese Gruppenbelohnung nicht berücksichtigt."
    ],
    "buffTiming": "Klassen- und Talenteffekte werden bei Einreichung pro Person gespeichert; bei überarbeiteter Neueinreichung werden sie erneut erfasst. Eventfaktor und Gildenausbau werden in der ersten Tribunalprüfung festgehalten. Spätere Änderungen erhöhen die laufende Prüfung nicht nachträglich.",
    "outcomes": [
      {
        "title": "Rückgabe zur Überarbeitung",
        "text": "Anna kann Beschreibung und Verteilung überarbeiten und mit einem Nachweis erneut einreichen. Eine neue Prüfrunde beginnt; alte Freigaben gelten dafür nicht. Das Tribunal ändert die Anteile nicht selbst. Während der Rückgabe ist die Aktion kein offener Slot."
      },
      {
        "title": "Ablehnung und Einspruch",
        "text": "Bei Ablehnung gibt es keine Belohnung. Einreicher oder bestätigte Teilnehmer können begründet Einspruch einlegen, standardmäßig einmal innerhalb von 30 Tagen und mit dem ursprünglichen Nachweis. Ein unabhängiger Systemadmin entscheidet. Ein genehmigter Einspruch eröffnet eine neue Tribunalrunde, er zahlt noch keine XP aus."
      },
      {
        "title": "Anzahl der Prüfungen",
        "text": "Standardmäßig genügt bis 150 Gruppen-XP eine Prüfung, bis 500 sind zwei nötig und darüber drei. Ab 500 muss eine Admin-Prüfung enthalten sein. Bei Stimmengleichstand folgt eine weitere Prüfung."
      },
      {
        "title": "Karma, Gildex und Benachrichtigungen",
        "text": "Positive Anteilsempfänger erhalten grundsätzlich mindestens +1 Karma, gegebenenfalls mit persönlichen Boni. Vom Tribunal vergebene Ehre wird gleichmäßig unter positiven Anteilsempfängern verteilt. 0 % gibt weder XP noch Karma. Die Gilde erhält einmal Gildex aus den Basis-XP, standardmäßig 10 %: im Beispiel 200 Gildex. Alle bestätigten Personen werden über das Ergebnis benachrichtigt, auch bei 0 %."
      },
      {
        "title": "Slot und Cooldown",
        "text": "Der Gruppen-Cooldown läuft ab Anmeldung, standardmäßig 24 Stunden, gegebenenfalls durch Effekte verkürzt. Solange die Aktion offen ist, bleibt der Slot auch nach Ablauf dieses Timers belegt. Die Auszahlung startet keinen neuen Timer. Abmeldung, Absage oder Ablehnung lösen die offene Reservierung auf."
      },
      {
        "title": "Gildenaustritt während der Aktion",
        "text": "Ein Austritt oder Ausschluss beendet die aktive Teilnahme. Bleiben bei einer eingereichten Aktion weniger als zwei bestätigte Personen, wird sie abgesagt. Bei weiteren verbleibenden Personen wird eine dadurch ungültige XP-Verteilung nicht automatisch umgerechnet; sie muss vor einer Freigabe geklärt und gegebenenfalls nach Rückgabe korrigiert werden."
      }
    ],
    "defaults": "Die Zahlen erklären den aktuellen Standard. Admins können Prüfgrenzen, Cooldowns, Gildex-Raten und Klasseneffekte konfigurieren. Bereits gespeicherte ältere Verteilungen bleiben für Auszahlung und Neuberechnung erhalten; neue oder geänderte Verteilungen verwenden ganze Prozent.",
    "assessmentBands": "Die beiden Skalen bestimmen die Bandnummer. Umfangreicher Gemeinschaftseinsatz mit „Viel geplant“ oder „Sehr hoch“ mit mehrstufiger Organisation ergibt Gruppenband 7 (standardmäßig 4.000–6.000 Basis-XP). Beide neuen höchsten Stufen ergeben Gruppenband 8 (6.000–10.000). Auch Gruppenbänder 1–6 haben eigene, höhere Pools. Alle Gruppenwerte sind unabhängig von Einzelaktionen konfigurierbar.",
    "assessmentExample": "Beispiel: Mehrere Teams werten eine Gemeinschaftsfläche an mehreren Arbeitstagen auf. Materialbeschaffung, Freigaben, Arbeitsphasen und Übergaben zwischen beteiligten Stellen müssen nachweisbar koordiniert werden. Beide neuen Stufen können passen; das Tribunal entscheidet anhand des tatsächlichen Einsatzes."
  },
  "systemCopy": {
    "16885658fbb9": " (Gildex)",
    "b5451aaa13ba": "Abenteurer",
    "d658d199540c": "0 XP",
    "42e2aa5470e7": " XP",
    "9717eb352337": "Experience Elixir",
    "3ba62c293ab6": "Gain 25% more XP for one individual deed per week.",
    "450864ab665b": "Einmal pro Woche 25 % mehr XP für eine Einzeltat.",
    "b6fbffaeb18a": " guild-shop",
    "5b3e5f590e60": "Gildex",
    "356db5eb31f6": " Gildex",
    "198fb678c812": "Guild statistics",
    "dbbcc055fb26": "Bestätigte Heldentaten",
    "5b11fe2f04f5": "Gildex verdient",
    "32d823725418": "Gildex earned",
    "15a3179e1e7c": "Heldentaten gegenüber dem vorherigen gleich langen Zeitraum:",
    "bae279e8bf55": "Gezählt ab Bestätigung, Zeitgrenzen in UTC. Historische Leistungen bleiben bei der damaligen Gilde.",
    "eda3a54706dc": "Counted from approval, with UTC period boundaries. Historical contributions stay with their original guild.",
    "84283337e247": "Heldentaten im Zeitverlauf",
    "71bcfe99e01b": "In diesem Zeitraum wurden noch keine Heldentaten bestätigt.",
    "7bd7d6d2efe7": "Aktive Mitglieder im Verhältnis zur gesamten Gilde",
    "b5cacdba5528": "Active members compared with the whole guild",
    "5f9d50483c1f": "Aktiv: mindestens eine bestätigte Einzelaktion für die Gilde oder Teilnahme an einer bestätigten Gruppenaktion. Gruppenteilnahmen zählen je Aktion, auch von ehemaligen Mitgliedern.",
    "4c6cf7cc1111": "Active: at least one approved individual deed for this guild or participation in an approved group deed. Participations count per deed, including former members.",
    "238c6eef4ba3": "Mit eurer ersten bestätigten Heldentat erscheint hier eure Wirkung nach Kategorien.",
    "3eb20d7dca1d": "Jede Heldentat zählt einmal, unabhängig von ihrer Teilnehmerzahl.",
    "325ba8c1e5d9": "Gildex & Ausbau",
    "f4e4094a94ea": "Gildex & development",
    "90d3ccca50df": "Gildex-Einnahmen und Ausgaben im gewählten Zeitraum",
    "ee36e9ddce32": "Gildex earned and spent in the selected period",
    "2f1d49da1e23": "Direkt beigetragene Gildex",
    "06097c96531f": "Directly contributed Gildex",
    "4d7fdae14b17": "Gruppenbelohnungen gehören der Gilde und werden hier nicht auf einzelne Mitglieder aufgeteilt.",
    "fd5c00369a49": "Group rewards belong to the guild and are not divided among individual members here.",
    "3e637b9d2de6": "Unlock the Trophy Room in the Gildex shop to open this gallery.",
    "982a1365d123": "Schaltet den Trophäenraum im Gildex-Shop frei, um diese Galerie zu öffnen.",
    "9cb479db5d4b": "Guild legacy",
    "73d8a14f8596": "Vermächtnis der Gilde",
    "dc596278d9f5": "A lasting record of the guild’s verified deeds and the members who accomplished them together.",
    "ec8d38bd7fe7": "Loading the guild’s achievements…",
    "80572bae1749": "Lade die Erfolge der Gilde…",
    "f5edf45aeade": "Unlock Group Good Deeds in the Gildex to start creating shared achievements.",
    "230b5c30d1bf": "Schaltet Gruppenaktionen im Gildex frei, um gemeinsame Erfolge zu schaffen.",
    "9efd79edc63b": "Wappen gestalten",
    "6722387741d7": "Wappen-Baukasten (Elemente)",
    "b4b39cdd92fe": "Wappenschmiede Freigeschaltet",
    "2e83774788fc": "Zufällige Wappenkombination",
    "3f12c55949e4": "Wappen Live-Vorschau",
    "2ffc7869e9b2": "Heraldisches Gildenwappen",
    "3d87aefea2a1": "Wappenschmiede Preview",
    "419dedf5e19c": "This crest uses exclusive forge elements. Unlock the Advanced Forge in the Guild Treasury shop with Gildex to apply it.",
    "584aea7f9abe": "Dieses Wappen nutzt exklusive Schmiede-Elemente. Schalte die \"Erweiterte Wappenschmiede\" im Gilden-Shop mit Gildex frei, um es dauerhaft zu speichern.",
    "831cefa91ceb": "Open Gildex Treasury",
    "0122936e8034": "Zur Gildex-Schatzkammer",
    "c36f48b7d236": "Klassische Standard-Wappen",
    "d2b13ba3aa87": "Wähle eine bewährte Standard-Kombination oder wechsle zum Wappen-Baukasten für individuelle Elemente.",
    "2f03025fd913": "In der Vorschau ziehen oder die Regler verwenden. Änderungen werden im Wappen gespeichert.",
    "2dd43870a02b": "Krone, Ritterhelm, Flamme oder Zinnen auf dem Wappen:",
    "111aabea36e8": "Lower base finish, guild ribbon banner, or gem pendant:",
    "0abdafe40412": "Unterer Wappenabschluss, Gilden-Banner oder Quaste:",
    "c6c2f4224b32": "Wähle den metallischen Glanz und die Farbtönung des Wappens:",
    "f1e9205cbb92": "Wappenschmiede",
    "168aad3e9812": "XP",
    "a9127cc07e92": "XP-Hilfe und Beispiele",
    "6a389d6c728d": " Karma",
    "6b2f2ecdd84a": " world-karma--stages",
    "eeafe73f02c8": "Höchste XP",
    "3b3f1e54984f": "Niedrigste XP",
    "f0a96bd6bf15": "Guild Master",
    "8bc9c6dd8644": " % XP",
    "687dfd0ceeee": "Gilde:",
    "e3e062929a2f": "Failed to apply emblem during guild creation",
    "31ba47f1fae3": "Taverne",
    "08db035d1806": "Gildenruhm und Aktivität sind derzeit nicht verfügbar.",
    "845d8127c1b4": "Gildenruhm und Aktivität konnten nicht geladen werden.",
    "a0a2ab9585a4": "Gildenhaus konnte nicht geladen werden.",
    "222a24fd9aa5": "Gilden-Neuigkeiten konnten nicht geladen werden.",
    "1c07813d09ea": "Gildenchat konnte nicht geladen werden.",
    "516773403e48": "Die angeforderte Gilde existiert nicht.",
    "21e1aeea2c1b": "Gildenverwaltung & Einstellungen",
    "f933fee4b73b": "Gildenruhm & Statistiken",
    "8e21174aef60": "Erfordert Gildex Freischaltung (Vize-Admin)",
    "867d4690e877": "Aus Gilde entfernen (Kick)",
    "5e0664b086b3": "Dauerhaft aus Gilde bannen",
    "ee84b83e2a24": "Du kannst nur einer Gilde gleichzeitig angehören.",
    "e47bab3c5826": "Erfahrungselixier: +25 % Gesamt- und Kategorie-XP bei Bestätigung, ohne XP-Kosten.",
    "a9096aac522c": "World Guild",
    "ab83d1ff771b": "Karma-Score",
    "55681e642a13": "Failed to fetch tavern feed",
    "00dc19d908f2": "Fehler beim Laden der Klassendaten.",
    "ccdf9223f7db": " neue Klasse",
    "8de641bae922": " Heldenklassen & Perks (",
    "504823c82e3b": "Klasse bearbeiten",
    "e6ee49712127": "Heldenklasse bearbeiten",
    "28b620216833": "Neue Heldenklasse anlegen",
    "a05731e81733": "Rolle / Klassentyp",
    "c58be06c1a93": "Klassen-Perk bearbeiten",
    "eff481858079": "Gesamt- und Kategorie-XP-Bonus",
    "90e7928d0517": "Party-Buff (Gruppen-XP)",
    "0f154384cef7": "Ehren-Karma Bonus (+1 Karma)",
    "11c40a51d425": "Karma-Erholung bei negativem Karma",
    "124911b8368c": "Kategorie-XP außerhalb der Zielkategorie",
    "db729f7363ab": "Erfahrungselixier (wöchentlich)",
    "031b655d8aaa": "Erholungs-Karma bis 0",
    "11fc673ba9d9": "Kategorie-XP-Bonus",
    "7558dba0c23d": "Gildex-Einzahlungsbonus",
    "8d7a465d4068": "Gruppen-Karma-Bonus",
    "70fddef742f8": "Wirkungswert (z.B. 0.20 = +20 %, 1 = +1 Slot/Karma)",
    "63f8d339cf42": "Tribunal Moderation",
    "54dcaca4c076": "Tribunal (",
    "75deb356299a": "Gilden (",
    "633ba960808f": "Zum Tribunal",
    "c6d1fc947dc9": "Im Gute-Taten-Tribunal prüfen",
    "c466734f5af1": "XP ×",
    "10c26d79140f": "XP-Vorschau konnte nicht geladen werden.",
    "8118de5cc29c": "XP wurden neu berechnet und die Differenz gebucht.",
    "c8db42d0bd0d": "XP konnten nicht neu berechnet werden.",
    "6f14360d1a0d": "Einstufung & XP-Vergabe",
    "3d62c442615b": "Passe Schwierigkeit und Komplexität an, um das verbindliche XP-Band festzulegen.",
    "1f7c933aceb6": "Basis-XP (Gruppe)",
    "26b475ca7301": "Kategorie-XP (Gruppe)",
    "a73feda6e2f7": " XP.",
    "c65a3b3858ce": " XP neu berechnen",
    "5d35f4fca941": "Gesamt-XP:",
    "cb874e449969": " · Kategorie-XP:",
    "b35858b78ad4": " XP, Kategorie",
    "c23e3acfe229": "XP-Hilfe",
    "78b14b08dc14": "Gute Tat oder Abenteurer…",
    "1443b9f2211c": "Alle XP-Bänder",
    "1698e4ae6293": "z. B. Taverne zum Drachen",
    "a677958fe6cc": "z. B. drachentaverne",
    "e00e689f3fc3": "info@drachentaverne.de",
    "0e6ec4da3067": "Genehmigte Bewerber erscheinen hier als aktive Tribunal-Moderatoren.",
    "f4a2115ad657": " XP /",
    "21591951cece": " XP)",
    "a190c9987e71": " XP ·",
    "e166da59b506": "Abenteurer (D)",
    "4c99fbbb2a76": "Beschreibe dein Angebot und wie Abenteurer es einlösen können (z.B. Zeige deinen Gildenpass an der Kasse oder nutze den Online-Code)...",
    "3937a00a22e5": "Standard: Für alle Abenteurer offen (ab Rang F)",
    "c7c3aa207e26": "Mindest-Gesamt-XP (optional)",
    "b001b3bb128a": "Mindest-Kategorie-XP",
    "438e079b21c4": "Mindest-Karma (optional)"
  },
  "effectDescriptions": {
    "CategoryRewardBonus": "{{percent}} % mehr Gesamt- und Kategorie-XP bei bestätigten guten Taten in {{category}}.",
    "CategoryExperienceBonus": "{{percent}} % mehr Kategorie-XP in {{category}}.",
    "GuildGildexContributionBonus": "{{percent}} % zusätzliche Gildex aus eigenen bestätigten Einzelaktionen für deine Gilde.",
    "HeroicActionXpBonus": "{{percent}} % mehr XP bei bestätigten guten Taten.",
    "PartyBuff": "{{percent}} % mehr Gruppen-XP. Mehrere gleiche Klassenboni werden nicht addiert.",
    "KarmaBonus": "{{value}} zusätzliches Karma pro bestätigter guter Tat, auch bei Gruppenaktionen.",
    "GroupKarmaBonus": "{{value}} zusätzliches Karma bei bestätigten Gruppenaktionen.",
    "KarmaRecoveryBonus": "{{value}} zusätzliches Erholungs-Karma bei negativem Karma.",
    "OtherCategoryExperienceBonus": "{{percent}} % mehr Kategorie-XP außerhalb von {{category}}.",
    "WeeklyExperienceElixir": "Einmal pro Kalenderwoche vor einer Einzelaktion aktivieren: {{percent}} % mehr Gesamt- und Kategorie-XP bei Bestätigung.",
    "ClassKarmaRecovery": "Bei negativem Karma {{value}} zusätzliches Erholungs-Karma je bestätigter guter Tat, höchstens bis 0."
  },
  "unlocks": {
    "STAMMTISCH": {
      "name": "Stammtisch & Chat",
      "description": "Schaltet den Gilden-Stammtisch und internen Text-Chat für eure Gildenmitglieder frei."
    },
    "DEPUTY_ADMIN": {
      "name": "Stellvertreter",
      "description": "Ermöglicht dem Gildenleiter das Ernennen von Stellvertretern, die bei der Verwaltung helfen."
    },
    "HALL_THEME_FOREST": {
      "name": "Waldhalle",
      "description": "Schaltet ein schönes Waldmotiv für die Ansicht eures Gildenhauses frei."
    },
    "GROUP_HEROIC_ACTIONS": {
      "name": "Gruppenaktionen",
      "description": "Erlaubt eurer Gilde, gemeinsame gute Taten zu starten und als Team größere Quests zu meistern."
    },
    "GUILD_EMOJI_PACK": {
      "name": "Stammtisch Plus",
      "description": "Schaltet Gilden-Emotes, Nachrichtenreaktionen, angeheftete Nachrichten und Umfragen im Gildenchat frei."
    },
    "BANNER_FORGE_ADVANCED": {
      "name": "Erweiterte Wappenschmiede",
      "description": "Schaltet erweiterte Bearbeitungs- und Gestaltungsoptionen für euer Gildenwappen frei."
    },
    "TROPHY_ROOM": {
      "name": "Trophäenraum"
    },
    "HALL_THEME_CELESTIAL": {
      "name": "Sternenhalle",
      "description": "Das Premium-Design! Schaltet das extrem seltene und wertvolle Sternenmotiv für euer Gildenhaus frei."
    },
    "EXP_BOOST_1": {
      "name": "XP-Boost I",
      "description": "Gewährt allen Gildenmitgliedern passiv +1% XP bei ihren guten Taten."
    },
    "EXP_BOOST_2": {
      "name": "XP-Boost II",
      "description": "Gewährt allen Gildenmitgliedern passiv +2% XP bei ihren guten Taten."
    },
    "EXP_BOOST_3": {
      "name": "XP-Boost III",
      "description": "Gewährt allen Gildenmitgliedern passiv +3% XP bei ihren guten Taten."
    },
    "EXP_BOOST_4": {
      "name": "XP-Boost IV",
      "description": "Gewährt allen Gildenmitgliedern passiv +4% XP bei ihren guten Taten."
    },
    "EXP_BOOST_5": {
      "name": "XP-Boost V",
      "description": "Gewährt allen Gildenmitgliedern passiv +5% XP bei ihren guten Taten."
    }
  },
  "legalContent": {
    "title": "Rechtliches & Datenschutz",
    "updated": "Stand: 28. September 2026",
    "tabs": [
      "Impressum",
      "Nutzungsbedingungen",
      "Datenschutz"
    ],
    "sections": [
      [
        [
          "Diensteanbieter",
          [
            "Goodvale",
            "Betreiber: Dipl. Ing. Thomas Johannes Trügler",
            "Kontakt: thomas@truegler.io",
            "Datenschutz: thomas@truegler.io"
          ]
        ]
      ],
      [
        [
          "1. Plattformzweck",
          [
            "Goodvale ist eine Gamification-Plattform für freiwillige, selbst gemeldete gute Taten. Das Tribunal prüft Nachweise und vergibt XP. XP bilden Spielfortschritt ab, sind nicht übertragbar, nicht auszahlbar und haben keinen festen Geldwert."
          ]
        ],
        [
          "2. Freiwilligkeit und keine verdeckte Arbeit",
          [
            "Gute Taten dürfen keine Beschäftigung, Arbeitsschicht oder reguläre kommerzielle Dienstleistung ersetzen. Gildenaktionen müssen freiwillig, sicher und nichtkommerziell organisiert sein. Partner dürfen keine Aufträge über Gilden oder gute Taten steuern und sind nur für selbst angebotene Vorteile verantwortlich."
          ]
        ],
        [
          "3. Einreichung und Beweise",
          [
            "Einreichende müssen wahrheitsgemäße Angaben machen, Rechte an hochgeladenen Dateien besitzen und unnötige personenbezogene Daten Dritter vermeiden. Gefährliche, rechtswidrige oder manipulierte Aktivitäten werden nicht belohnt. Externe Beweislinks sind nicht zulässig."
          ]
        ],
        [
          "4. Tribunal und Einspruch",
          [
            "Die erste zugewiesene Prüfung legt Schwierigkeit, Komplexität und Basis-XP innerhalb der administrierten Range fest. Die XP-Höhe bestimmt die Zahl unabhängiger Prüfungen; hohe Werte benötigen zusätzlich einen Admin. Erst das vollständige Quorum entscheidet per Mehrheit. Bei Gleichstand wird eine weitere Prüfung zugewiesen. Gegen eine Ablehnung kann innerhalb der konfigurierten Frist Einspruch erhoben werden."
          ]
        ],
        [
          "5. Gruppenaktionen",
          [
            "Gildenadmins dürfen freiwillige Gruppenaktionen ausrufen. Mitglieder melden sich selbst an und bestätigen ihre tatsächliche Teilnahme erst ab Beginn. Organisierende verteilen die Gesamt-XP auf bestätigte Teilnehmende; niemand darf mehr als 50 % erhalten. Das Tribunal prüft die Verteilung. Organisierende bleiben für Genehmigungen, Sicherheit und die nichtkommerzielle Durchführung verantwortlich."
          ]
        ],
        [
          "5a. Gildex",
          [
            "Gildex sind nicht käufliche, nicht übertragbare und nicht auszahlbare interne Gilden-Fortschrittspunkte ohne Geldwert. Sie werden zusätzlich zu Spieler-XP aus einem administrierbaren Anteil bestätigter Basis-XP erzeugt und können ausschließlich für interne Gildendekorationen und Komfortfunktionen verwendet werden. Sie gelten nicht bei Partnern oder außerhalb von Goodvale."
          ]
        ],
        [
          "6. Partnerangebote",
          [
            "Partner legen Freischaltungen anhand von Rang, Level, Gesamt-XP, Kategorie-Fortschritt oder einer bestätigten Systemaktion fest. XP werden bei der Einlösung nicht verbraucht. Einlösungen erfordern einen kurz gültigen, signierten QR-Pass; jede QR-Sitzung kann nur einmal verwendet werden. Vertrag, Verfügbarkeit und Erfüllung des Vorteils liegen beim Partner."
          ]
        ],
        [
          "7. Klassen, Boosts und Karma",
          [
            "Klassen- und Talentboni verändern ausschließlich Spielwerte. Das Erfahrungselixier des Alchemisten ist kostenlos und einmal pro Kalenderwoche verfügbar. Die Einreichung verbraucht die Ladung auch bei späterer Ablehnung oder Rückzug. Karma bleibt ein separater Vertrauens- und Regelwert."
          ]
        ],
        [
          "8. Sicherheit und Sanktionen",
          [
            "Mehrfachverwendung von Beweisen, QR-Manipulation, Täuschung, Belästigung oder Umgehungsversuche können zur Ablehnung, Einschränkung oder Sperre führen."
          ]
        ],
        [
          "9. Haftung",
          [
            "Goodvale prüft Plattformnachweise, garantiert aber weder die Sicherheit einer Tätigkeit vor Ort noch behördliche Genehmigungen oder die Erfüllung eines Partnerangebots. Gesetzliche Haftung, insbesondere für Vorsatz, grobe Fahrlässigkeit und Personenschäden, bleibt unberührt."
          ]
        ],
        [
          "10. Teilnahme, Registrierung und Vertrag",
          [
            "Goodvale richtet sich an Personen ab 18 Jahren. Mit der Registrierung bestätigst du deine Volljährigkeit und akzeptierst diese Nutzungsbedingungen. Der Nutzungsvertrag kommt mit der Freischaltung des Kontos zustande; Partnerkonten benötigen eine gesonderte Freigabe. Angaben müssen zutreffend sein. Schütze deine Zugangsdaten und melde einen vermuteten Missbrauch. Die Registrierung begründet keinen Anspruch auf bestimmte Partnerangebote oder Belohnungen."
          ]
        ],
        [
          "11. Rechte an Inhalten",
          [
            "Deine Inhalte bleiben deine Inhalte. Du räumst Goodvale nur die nicht ausschließlichen Nutzungsrechte ein, die zum Speichern, technisch erforderlichen Bearbeiten, Anzeigen im von dir gewählten Sichtbarkeitsbereich und Prüfen erforderlich sind. Eine darüber hinausgehende Werbenutzung benötigt eine gesonderte Erlaubnis. Du darfst nur Inhalte hochladen, für die du die erforderlichen Rechte besitzt. Bei Löschung enden die Nutzungsrechte, soweit keine zulässige Aufbewahrung oder Abwicklung offener Verfahren erforderlich ist."
          ]
        ],
        [
          "12. Kündigung und Änderungen",
          [
            "Du kannst die Nutzung jederzeit beenden und dein Konto im Profil löschen oder die Kündigung unter thomas@truegler.io erklären. Bei Gildenleitung kann zuvor die Übergabe der Leitung oder Auflösung der Gilde erforderlich sein; dein Recht zur Kündigung bleibt bestehen. Eine sofortige Sperre aus wichtigem Grund bleibt möglich, insbesondere bei erheblichen Rechtsverletzungen oder Sicherheitsgefahren.",
            "Wesentliche Änderungen der Nutzungsbedingungen werden vor ihrem Wirksamwerden verständlich angekündigt. Soweit eine Zustimmung erforderlich ist, holen wir sie ausdrücklich ein; Schweigen gilt nicht als Zustimmung. Du kannst vor Wirksamwerden kündigen. Technische Wartung und Weiterentwicklung können die Verfügbarkeit und Spielregeln verändern; zwingende gesetzliche Rechte bleiben bestehen."
          ]
        ],
        [
          "13. Meldung rechtswidriger Inhalte",
          [
            "Nutzer und Behörden erreichen unsere Kontaktstelle unter thomas@truegler.io in deutscher oder englischer Sprache. Für Inhaltsmeldungen verwende möglichst den Betreff „Inhaltsmeldung“ und nenne den genauen Link oder die eindeutige Inhaltskennung, den Grund der vermuteten Rechtswidrigkeit und gegebenenfalls Belege. Gib Namen und E-Mail-Adresse sowie eine Erklärung an, dass deine Angaben nach bestem Wissen richtig und vollständig sind; gesetzliche Ausnahmen von Identitätsangaben bleiben unberührt.",
            "Wir bestätigen den Eingang, prüfen Meldungen sorgfältig und unparteiisch und informieren über die Entscheidung und mögliche Rechtsbehelfe, soweit uns Kontaktdaten vorliegen. Übermittle keine unnötigen sensiblen Daten. Diese Kontaktstelle ist kein Notruf."
          ]
        ],
        [
          "14. Moderation und Beschwerden",
          [
            "Verboten sind insbesondere rechtswidrige Inhalte, Drohungen, Belästigung, Veröffentlichung privater Daten Dritter, Rechteverletzungen und manipulierte Nachweise. Je nach Schwere, Wiederholung und Gefährdung können Inhalte eingeschränkt oder entfernt, Einreichungen abgelehnt und Konten vorübergehend oder dauerhaft gesperrt werden. Automatische Prüfungen unterstützen die Erkennung und Zuweisung; strittige Maßnahmen werden von Menschen überprüft.",
            "Betroffene erhalten, soweit rechtlich zulässig, eine verständliche Begründung mit maßgeblichen Umständen, Regelgrundlage, Umfang und Dauer der Maßnahme sowie dem Beschwerdeweg. Gegen Moderationsmaßnahmen kannst du innerhalb von sechs Monaten kostenlos unter thomas@truegler.io mit dem Betreff „Moderationsbeschwerde“ vorgehen. Nenne die Entscheidung und deine Einwände. Die Überprüfung erfolgt durch eine befugte Person und nicht ausschließlich automatisiert. Fehlerhafte Maßnahmen werden korrigiert. Für XP- und Tatentscheidungen gilt zusätzlich der in der App angezeigte Tribunal-Einspruchsweg. Gesetzliche gerichtliche und außergerichtliche Rechtsbehelfe bleiben unberührt."
          ]
        ],
        [
          "15. Anwendbares Recht",
          [
            "Es gilt österreichisches Recht. Zwingende Verbraucherschutzvorschriften deines gewöhnlichen Aufenthaltsstaats bleiben anwendbar, soweit gesetzlich vorgesehen. Gesetzliche Gerichtsstände werden nicht eingeschränkt."
          ]
        ]
      ],
      [
        [
          "1. Verantwortlicher",
          [
            "Verantwortlicher ist der im Impressum genannte Betreiber. Datenschutzanfragen: thomas@truegler.io."
          ]
        ],
        [
          "2. Verarbeitete Daten und Zwecke",
          [
            "Verarbeitet werden Konto- und Profildaten, Fortschritt, Karma, Gildenmitgliedschaft, Gildex-Buchungen und Freischaltungen, Einreichungen, Tribunalentscheidungen, Einsprüche, Partner-Einlösungen, Nachrichten, Push-Abonnements sowie Sicherheits- und Zugriffsprotokolle. Zwecke sind Kontoführung, Spielbetrieb, Missbrauchsschutz, Kommunikation und Nachweisprüfung."
          ]
        ],
        [
          "3. Rechtsgrundlagen",
          [
            "Kontoführung, Kommunikation, Prüfung eingereichter Taten und Einlösung von Vorteilen erfolgen, soweit dafür erforderlich, nach Art. 6 Abs. 1 lit. b DSGVO. Optionale Umami-Statistik und Sentry-Fehlerdiagnose im Browser beruhen jeweils auf deiner gesonderten Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO. Sicherheitsprotokolle, serverseitige Fehlerdiagnose und Missbrauchsabwehr dienen unseren berechtigten Interessen am sicheren und fairen Betrieb (Art. 6 Abs. 1 lit. f DSGVO). Gesetzliche Aufbewahrungs- und Auskunftspflichten erfüllen wir nach Art. 6 Abs. 1 lit. c DSGVO.",
            "E-Mail-Adresse, Zugangsdaten und die für deine Rolle erforderlichen Angaben sind für ein Konto notwendig. Ohne diese Angaben kann kein Konto bereitgestellt werden. Optionale Angaben und Tracking-Einwilligungen sind keine Voraussetzung für die allgemeine Nutzung. Du kannst Einwilligungen jederzeit für die Zukunft widerrufen; die Rechtmäßigkeit der bisherigen Verarbeitung bleibt unberührt."
          ]
        ],
        [
          "4. Beweisdatenschutz",
          [
            "Die Verarbeitung eines von dir gewählten Nachweises dient der von dir angeforderten Prüfung deiner Tat (Art. 6 Abs. 1 lit. b DSGVO). Die Bestätigung vor dem Upload bestätigt die Beweisregeln; sie ist keine pauschale Einwilligung in beliebige Datenverarbeitung. Dateien werden verschlüsselt außerhalb öffentlicher Webverzeichnisse gespeichert. Zugriff erhalten die einreichende Person, zugewiesene Prüfer und berechtigte Administratoren; Zugriffe werden protokolliert.",
            "Lade nur erforderliche Nachweise hoch. Mache unbeteiligte Personen, Kennzeichen und private Anschriften unkenntlich. Lade keine Gesundheitsunterlagen, Ausweisdokumente oder anderen sensiblen Angaben über dich oder Dritte hoch. Die Uploadbestätigung ersetzt keine Rechte oder Rechtsgrundlage für Daten Dritter.",
            "Ab Prüfungsbeginn ist die direkte Selbstlöschung einzelner Beweise eingeschränkt, um das Verfahren nachvollziehbar zu halten. Du kannst dennoch jederzeit unter thomas@truegler.io Löschung, Einschränkung oder Rücknahme der Einreichung beantragen. Wir prüfen den Einzelfall; eine weitere Aufbewahrung erfolgt nur bei einer tragfähigen Rechtsgrundlage, etwa zur notwendigen Rechtsverteidigung. Die technische Einschränkung hebt deine gesetzlichen Rechte nicht auf."
          ]
        ],
        [
          "5. Empfänger und Auftragsverarbeiter",
          [
            "Daten erhalten nur technisch oder fachlich notwendige Empfänger, etwa Hosting-, Push- oder Sicherheitsdienstleister auf vertraglicher Grundlage. Partner sehen beim QR-Scan nur die für Berechtigung und Einlösung erforderlichen Daten."
          ]
        ],
        [
          "5a. Hetzner – Hosting",
          [
            "Wir nutzen Hetzner Online GmbH für die Hosting-Infrastruktur von Goodvale. Dabei werden die für den Plattformbetrieb gespeicherten Daten sowie technische Verbindungs- und Zugriffsdaten, insbesondere IP-Adresse, Zeitpunkt und angeforderte Ressourcen, verarbeitet. Dies dient der Bereitstellung, Verfügbarkeit und Sicherheit der Plattform auf Grundlage der Vertragserfüllung und unserer berechtigten Interessen an einem sicheren Betrieb."
          ],
          "https://www.hetzner.com/legal/privacy-policy/"
        ],
        [
          "5b. Sentry – Fehlerdiagnose",
          [
            "Sentry dient der Erkennung und Behebung technischer Fehler. Dabei können Fehlermeldungen, Stacktraces, technische Browser-, Geräte- und Anfragedaten sowie Leistungsdaten verarbeitet werden. Die Fehlererfassung im Browser wird erst nach deiner Einwilligung aktiviert und kann über die Tracking-Einstellungen widerrufen werden. Die automatische Übermittlung zusätzlicher personenbezogener Daten ist im Browser deaktiviert. Die serverseitige Fehler- und Leistungsdiagnose erfolgt unabhängig davon zur Sicherung des Betriebs auf Grundlage unserer berechtigten Interessen."
          ],
          "https://sentry.io/privacy/"
        ],
        [
          "5c. Umami – Nutzungsstatistik",
          [
            "Umami erfasst nach deiner Einwilligung Seitenaufrufe und technische Nutzungsdaten, etwa aufgerufene URLs, Verweisquellen sowie Browser- und Geräteinformationen. Wir nutzen diese Statistik, um die Nutzung und Bedienbarkeit von Goodvale zu verstehen und zu verbessern. Du kannst die Erfassung jederzeit in den Tracking-Einstellungen deaktivieren. Die Verarbeitung erfolgt über die für Goodvale konfigurierte Umami-Instanz."
          ],
          "https://docs.umami.is/"
        ],
        [
          "5d. Firebase – Push-Benachrichtigungen",
          [
            "Für Push-Benachrichtigungen auf Android verwenden wir Firebase Cloud Messaging von Google. Dabei werden Geräte-Registrierungstoken, technische Zustellungsdaten und die Benachrichtigungsdaten verarbeitet. Goodvale versendet einen allgemeinen Hinweis auf neue Benachrichtigungen sowie Typ und Referenzkennung, keine Nachrichtentexte aus Chats. Die Zustellung erfolgt nach Aktivierung und Erteilung der Geräteberechtigung. Du kannst Push-Benachrichtigungen in den Geräteeinstellungen deaktivieren."
          ],
          "https://firebase.google.com/support/privacy"
        ],
        [
          "5e. Resend – E-Mail-Versand",
          [
            "Resend versendet transaktionale Kontomails, insbesondere zur Bestätigung deiner E-Mail-Adresse und zum Zurücksetzen des Passworts. Dazu werden Empfängeradresse, E-Mail-Inhalt einschließlich Bestätigungs- oder Rücksetzlink sowie technische Versand- und Zustellungsdaten verarbeitet. Dies dient der Kontoführung und Kontosicherheit auf Grundlage der Vertragserfüllung und unserer berechtigten Interessen am Schutz von Nutzerkonten."
          ],
          "https://resend.com/legal/privacy-policy"
        ],
        [
          "5f. Karten und Standort",
          [
            "Karten werden mit Kacheln der OpenStreetMap Foundation geladen. Beim Öffnen einer Kartenfunktion werden insbesondere IP-Adresse, technische Anfragedaten und der angeforderte Kartenausschnitt an deren Server übermittelt. Dies dient der angeforderten Kartenanzeige und unserem berechtigten Interesse an einer funktionierenden Ortsdarstellung. Der Kartenausschnitt kann Rückschlüsse auf den betrachteten Ort zulassen.",
            "Die Standortfreigabe deines Geräts ist optional und erfordert dessen Berechtigung. Manuell angegebene Standorte, öffentliche Gilden- oder Partnerorte und freiwillige GPS-Nachweise werden für die jeweilige Funktion verarbeitet. Öffentlich eingegebene Orte sind für andere sichtbar; GPS-Nachweise gehören zur geschützten Einreichung."
          ],
          "https://osmfoundation.org/wiki/Privacy_Policy"
        ],
        [
          "5g. Apple-Push auf iOS",
          [
            "Auf iOS erfolgt die Zustellung über Apple Push Notification service (APNs). Verarbeitet werden Gerätetoken, technische Zustellungsdaten, ein allgemeiner Benachrichtigungshinweis sowie Typ und Referenzkennung. Die Funktion setzt deine Aktivierung und Geräteberechtigung voraus; diese kannst du in den Geräteeinstellungen widerrufen."
          ],
          "https://www.apple.com/legal/privacy/"
        ],
        [
          "5h. Sichtbarkeit und Empfänger innerhalb von Goodvale",
          [
            "Öffentliche Profilangaben wie Nutzername, gewähltes Profilbild, Beschreibung und angezeigter Spielfortschritt können anderen Nutzern beziehungsweise Besuchern angezeigt werden. Veröffentliche dort keine vertraulichen Angaben. Gildeninhalte sind entsprechend der jeweiligen öffentlichen oder mitgliederbezogenen Funktion sichtbar. Direktnachrichten sind für die Gesprächsbeteiligten, Gildenchats für die jeweiligen Mitglieder bestimmt. Berechtigte Administratoren können Daten bearbeiten, soweit dies für Betrieb, Support oder die Prüfung konkreter Missbrauchsmeldungen erforderlich ist.",
            "Tribunalmitglieder erhalten nur im Rahmen ihrer Zuweisung Zugriff auf geschützte Nachweise. Partner erhalten die für eine Einlösung erforderlichen Berechtigungs- und Einlösungsangaben. Plattformdaten werden nicht allein dadurch öffentlich, dass sie für eine Prüfung eingereicht werden."
          ]
        ],
        [
          "5i. Regionen und internationale Übermittlungen",
          [
            "Die Hosting-Infrastruktur bei Hetzner und die dort selbst betriebene Umami-Instanz liegen in Europa. Bei externen Diensten verwenden wir die verfügbaren und konfigurierten EU-Datenregionen. Eine EU-Speicherregion schließt Zugriffe oder Verarbeitung durch internationale Anbieter und Unterauftragnehmer außerhalb des EWR nicht automatisch aus, insbesondere bei weltweiten Push- und E-Mail-Diensten.",
            "Für Übermittlungen außerhalb des EWR ist ein Angemessenheitsbeschluss nach Art. 45 DSGVO oder eine geeignete Garantie nach Art. 46 DSGVO erforderlich, insbesondere EU-Standardvertragsklauseln mit gegebenenfalls zusätzlichen Schutzmaßnahmen. Eine Zertifizierung unter dem EU-US Data Privacy Framework kann nur herangezogen werden, soweit der konkrete Empfänger und die Verarbeitung davon erfasst sind. Informationen zu den für deine Daten einschlägigen Empfängern, Garantien und einer Kopie der Garantien erhältst du unter thomas@truegler.io."
          ]
        ],
        [
          "6. Speicherdauer",
          [
            "Kontodaten bleiben für die Dauer des Kontos gespeichert. Bei Kontolöschung werden insbesondere Kontaktdaten, Profilinhalte, Standortangaben, Beweise, Push-Abonnements sowie zugehörige Direkt- und eigene Gildenchatnachrichten gelöscht oder bereinigt. Laufende Einreichungen werden zurückgezogen. Pseudonymisierte Prüf- und Buchungsdaten können verbleiben; sie sind weiterhin personenbezogene Daten, soweit eine Zuordnung möglich ist.",
            "Für Beweise ist im System eine Regelfrist von 90 Tagen nach der endgültigen Entscheidung vorgesehen, mindestens jedoch bis sieben Tage nach Ende der anwendbaren Einspruchsfrist. Offene Verfahren und Einsprüche sind zu berücksichtigen. Eine abweichend erforderliche Aufbewahrung muss durch den konkreten Verfahrenszweck oder eine gesetzliche Grundlage gerechtfertigt sein.",
            "Für Sicherheits-, Diagnose-, Versand- und Prüfprotokolle richtet sich die erforderliche Dauer nach Fehlerbehebung, Zustellungsnachweis, Aufklärung eines konkreten Missbrauchsfalls oder Abwehr von Ansprüchen. Nicht mehr erforderliche personenbezogene Daten sind zu löschen oder tatsächlich zu anonymisieren; abgeschlossene Fälle rechtfertigen keine unbegrenzte Vorratsspeicherung. Bei gesetzlichen Pflichten gilt die jeweils einschlägige Frist. Lokale Einstellungen bleiben bis zur Änderung oder Löschung des Browserspeichers erhalten."
          ]
        ],
        [
          "7. Deine Rechte",
          [
            "Du kannst im Profil eine maschinenlesbare Datenkopie herunterladen und dein Konto anonymisieren. Zusätzlich bestehen – soweit gesetzlich anwendbar – Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerspruch und Beschwerde bei der österreichischen Datenschutzbehörde."
          ]
        ],
        [
          "8. Kontoanonymisierung",
          [
            "Bei Selbstlöschung werden Kontaktdaten und Beweisdateien entfernt und der Zugang gesperrt. Prüf-, Ledger- und Sicherheitsdatensätze können pseudonymisiert fortbestehen, wenn sie zur Integrität des Systems oder wegen gesetzlicher Pflichten benötigt werden."
          ]
        ],
        [
          "9. Rechte, Widerspruch und Kontakt",
          [
            "Für Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit oder Widerruf erreichst du uns unter thomas@truegler.io oder der Anschrift im Impressum. Gegen Verarbeitungen auf Grundlage berechtigter Interessen kannst du aus Gründen deiner besonderen Situation Widerspruch einlegen. Wir beantworten Anträge grundsätzlich innerhalb eines Monats; eine gesetzlich zulässige Verlängerung teilen wir mit Gründen mit. Du kannst dich bei der österreichischen Datenschutzbehörde beschweren."
          ],
          "https://dsb.gv.at/"
        ],
        [
          "10. Lokaler Speicher und automatisierte Regeln",
          [
            "Für Anmeldung, Sprache, Darstellung und Datenschutzentscheidungen verwenden wir lokalen Browserspeicher. Optionale Umami-Statistik und Sentry-Browserdiagnose sind getrennt wählbar und standardmäßig ausgeschaltet. Die Ablehnung beeinträchtigt die allgemeine Nutzung nicht. Über die Einstellungen unten kannst du deine Entscheidung ändern.",
            "XP, Freischaltungen, Karmaeffekte und Anti-Cheat-Prüfungen werden teilweise regelbasiert berechnet. Die Regeln betreffen den Spielfortschritt und die Prüfungszuweisung; Tribunalentscheidungen werden durch zugewiesene Menschen getroffen. Bei strittigen Ergebnissen kannst du eine menschliche Prüfung über die Einspruchsfunktion oder thomas@truegler.io verlangen."
          ]
        ]
      ]
    ]
  },
  "classAvailability": {
    "bonus": "Erfahrungselixier"
  }
}
